export function KingSpades(done: boolean) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 1483 2048"
      width="fit-content"
      height="200"
      xmlns="http://www.w3.org/2000/svg"
    >
      {done ? (
        <>
          <path
            transform="translate(0)"
            d="m0 0h1483v2048h-1483z"
            fill="#FCFCFC"
          />
          <path
            transform="translate(728,270)"
            d="m0 0h348l153 1v265l1 558v671l-1 1-420-1-585-2-1-1-1-23v-186l1-949 1-333z"
            fill="#020104"
          />
          <path
            transform="translate(0)"
            d="m0 0h1483v2048h-1483zm107 50-16 1-13 4-10 6-5 4-7 9-7 14-2 18v1828l2 14 4 9 7 11 9 8 11 6 10 3 11 1h1250l13-1 12-4 11-7 9-9 6-11 3-8 1-6v-1845l-3-11-5-10-9-10-9-7-12-5-4-1-17-1z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(239,284)"
            d="m0 0h266l4 4 21 32 13 21 14 24 13 24 13 23 11 19v2h4l-2-4-12-22-12-21-9-16-2-5 3 1 13 24 11 18 10 18 10 16h11l68-10 32-4 50-4 22-1h54l30 1 50 4 12 2 24 3h6l8-12 5-7 1 4-2 2-4 9 4-5 9-13 13-19 16-23 16-24 13-18 16-24 11-15 2-2h134l5 1 1 212v396l-2 5-9 1-5-2-1-2-1-128-1-347-14-13-8-7-12-11-9-8-5 1-10 10-8 7-11 10-8 7h-2v288l-4-1-11-6-13-8-29-15-15-8-28-13-15-7-6-4-5-8v-11l4-20v-12l-3-21-6-20-8-17h-3l1 6 5 8 7 21 2 10 1 10v17l-2 10-1 2-4-1-2-4-1-32-3-16-5-13v-2h-3l-1 1-2 4-1 8h2v-5l4 2 3 7 3 16v18l-5 1h-2l6 11 11 23 3 12v13l-2 9-5 8-7 6-5 2h-8l-1-1v-5l13-7 4-6 2-13-2-12-7-17-6-10v-3l-3 3 2 6 6 10 5 13 1 4v14l-4 8-6 4h-7l-1-3 8-10 1-2v-11l-6-15-1-4-3-1v-3h-2v4l2 1 1 5 5 10 1 10-4 6-5 1-4-7-2-6-5 6h3l6 15 4 15 1 7v10l-2 10-6 9-9 6-5 2h-14l-11-6-7-10-6-15-2-7 1-5 3-2h4l8 23 4 6 6 4 3 1h9l7-3 5-5 2-5 1-10-4-20-4-13-2-2-2 4 4 10 4 17v12l-3 6-5 4-6 2-9-1-7-8-5-13-2-11-1-3 1-3-13 4-9 2-3 5-10 22-9 15-4 5-11 7-10 3h-9l-11-2-8-4-5-4-6-10-3-9v-12l5-14 8-15 2-7h-4l-10 20-6 11-8 8-8 4-6 2h-16l-11-4-10-8-6-10-1-5v-9l3-12 7-16 13-25 2-7-3 1-15 28-8 14-8 9-8 4-7 2h-13l-10-4-7-5-4-7-2-4v-6l4-4 3 1 7 12 6 5 5 2h14l8-4 8-10 16-32 3-8v-4l-10 19-13 24-9 10-5 2h-12l-5-3-6-7-3-6 1-5h5l7 9 3 2h10l3-1 2-4 8-14 11-22 4-9v-5h-2l-2 6-14 29-7 12-5 4h-6l-4-2-5-8 1-5 10-13 8-11 3-1-3 11-7 19 3-3 8-18 11-27 1-6-3 3h-2l1-5 9-29 12-46 8-39 1-13-3 5-2 7-7 37-11 42-12 38-8 18-7 12-11 14-9 8h-4l1-5 11-19 7-15 10-26 10-31 8-32 7-38 2-14v-6h-4l-2 22-5 27-9 36-12 37-11 30-11 21-10 15-8 10-5 6-6 4-8 2-10 5-7 3-5 3h-4l2-5 11-14 14-22 12-22 11-25 10-27 7-21 8-32 5-26 1-8v-9l-2-2-4 28-6 27-8 26-10 29-12 29-9 20-10 18-10 14-9 11-12 12-8 4-8-1 2-4 10-9 11-14 10-16 13-25 12-28 11-28 11-34 10-41 2-11-5 1-8 39-7 25-12 34-12 29-13 28-11 19-12 17-11 11-11 7-8 3h-9l-3-1 1-3 11-7 10-8 11-11 12-18 15-29 9-19 13-33 8-24 9-34 3-17-2-1 3-13-3-1-3 21-6 26-9 29-15 41-10 23-10 19-12 18-11 14-9 9-14 9-9 4-10 1-10-2-3-3 1-3 2-1 15-2 10-4 11-8 8-10 10-15 10-17 13-26 11-27 12-36 10-40 4-17h-4l-2 13-10 40-11 33-12 28-9 20-12 21-12 17-8 10-7 7-12 7-8 2h-12l-9-3-5-5-6-8-2-5v-12l4-8 7-6 7-3h11l10 5 5 7 1 8-5 8-3 2h-8l-6-3-2-4 1-4 4-4v-2l-5 1-3 3-1 9 4 6 6 3h11l9-6 7-7 12-17 9-15 12-23 8-19 12-35 10-35 3-13v-7l-2 2-1 5-3 7-7 28-12 36-12 29-10 19-14 21-7 10-3-1-5-9-8-7-5-2h-14l-10 4-5 4-5 9-1 3v12l4 11 1 1v5l-42 13-19 7h-3v2l-8 5-2 2 9 11 11 14 14 19 12 17 14 24 10 18 9 17 14 32 10 28 9 32 6 29 4 30 2 26v42l-3 32-5 29-6 27-5 17-4-1-5-3 5-25 4-24 3-28 1-14v-32l-2-33-5-37-6-29-8-29-9-26-12-29-15-31-13-23-1-3-4-2 1 3 5 11 7 13-2 20v29l3 16 6 16 8 15 12 17 9 10 7 8 7 6 1 2 1 17-5-2-12-8-17-16-10-12-3-4-3 3 1 4-14 11-7 8-1 3v7l4 6 5 4h8l11-4 13-9 6-3 2 2-1 4-10 11-10 7-12 6h-3l-1 4 9-2 2-3 4 2 1 2 3-1 2-5 11-13 8-7 5 1-2 5-10 11-2 4v12l5 8 5 3h12l7-4h4v9l-5 5-9 6-6 1v2l-7 2 2 2h7l16-10h3v21l-6-1-14-6-12-4-18-11-10-8-12-9-8-7 2-4h2l-4-4-10-5-5-6-1-3v-12l5-10 3-4-2-1h3l-1-2h-6l-2 1 4 2v2h-2l-2 6-6 9h-3l-10-14-3-3-7-11-6-10-8-20-2-10-2-7-3-10-2-30v-13l1-3v-15l4-21 5-17 4-13 5-12 3-10 8-14 1-4-4-5v-2l-18 4-3 2-10 3-2 2-10 4-17 8-10 4-18 10-20 12-27 18-17 12-13 11-2-1v-351z"
            fill="#FCFCFC"
          />
          <path
            transform="translate(239,1133)"
            d="m0 0 14 1v474l3 5 14 13 8 7 10 9 8 7 4-1 10-9 11-9 11-10 10-8 1-2 1-281 6 2 110 55 5 5 4 8-1 13-3 14-1 17 2 17 4 16 7 17 6 9v2l2-1v-3l-3-1-3-5v-6l-6-14-4-19v-29l2-9 2-4h3l2 6v30l3 19 3 10 3-1-5-25-1-21 2-2 5 5 3 6 1 5v19l1-2h2v-2h2v-16l2-24-4-1-3-10-8-16-3-10v-15l4-6 7-4h7l2 6-9 6-2 3v7l4 13 3 6h2l-1-6-4-10v-8l4-3h6l2 4h2l-1-10-6-17-2-9v-17l3-8 4-5 10-6 3-1h16l9 4 6 7 8 19 3 9-1 4-6 1-4-9-5-13-7-9-5-2h-10l-8 3-5 5-2 7v8l4 16 5 14 1 1 1-6-5-15-2-8v-13l5-6 6-3h11l7 6 5 11 4 12-1 5-3 2-6 1-5 3-4 4-2-1-1 2h4v3l14-8 12-5 14-3 15-31 9-12 7-6 9-4 6-2h15l10 3 8 6 6 7 4 10 1 11-4 13-10 19-3 7 5-3 13-25 9-10 8-5 10-3h16l10 4 7 6 6 10 2 7 1 14-3 9-13 24-8 15-1 4 3-1 14-26 8-14 6-7 10-6 7-2h14l10 4 8 8 6 10 1 4-5 4-4-1-6-11-7-6-7-2-11 1-8 4-8 9-10 17-11 21-1 4 3 1 2-6 14-26 8-11 6-7 8-4h11l8 5 6 10-1 4-5 3-6-9-5-3-9 1-8 7-10 19-12 24-1 3 3-1 13-25 8-16 7-6 2-1h7l5 4 1 2v7l-11 13-9 16-11 27-10 30-2 16-4 15-1 8 2 1 9-36 9-29 8-21 10-21 8-10 11-11 6-2-1 6-9 15-11 23-10 26-11 33-9 36-3 17v5l3-3h2l1-11 5-24 10-34 10-28 14-32 12-23 7-10 11-11 7-4h4l-2 5-7 10-12 20-11 21-12 29-11 33-7 25-6 28-1 10h3l3-13 8-34 12-36 11-30 11-25 10-19 8-12 8-11 6-7 8-5h2v-2l7-1 1 3 9-7 6-2h22l3 1 3-1h12v2h11 4l9 1 5 5 5 4 8 4 2 3 12 1 19-7 34-14 20-8 8-4 18-7 24-11 25-12 34-17 19-10 23-13 22-13 8-6 3 1v494l-2 1h-264l-4-4-12-20-11-18-17-28-16-26-15-25-1 4-4-2-9-16-13-22-6-9-10 1-51 9-45 6-35 3-54 3h-35l-32-1-40-3-39-5-13-3-2-4-4 2-12 18-14 20-8 12-16 23-13 19-16 23-22 32-7 9h-135l-1-1-1-214v-230l1-103 1-69z"
            fill="#FCFCFC"
          />
          <path
            transform="translate(728,270)"
            d="m0 0h348l153 1v265l1 558v671l-1 1-420-1-585-2-1-1-1-23v-186l1-949 1-333zm-489 14-1 143v351h3l2-1-14 12-1 46v228l1 66 4 1h11l9 3h17v2l10 2 5 8 5 16 3 21 1 12v28l-4 26-6 37v32l4 23 9 36 6 23 1 6v19l-4 25-5 23-2 15-1 16 1 49 1 27 3-1 2-6v-75l5-30 6-30 2-21-1-16-4-20-10-37-3-18-1-14v-18l3-26 5-27 2-20v-38l-3-31-2-12 8 1 32 1-1 168v12l2 5 5 2-1 282-5 5-11 10-11 9-12 11-5 4-4-1-14-13-8-7-10-9-8-7-2-4v-474l-14-1-1 1-1 69-1 103v230l1 214 1 1h135l8-10 10-15 16-23 11-16 14-20 30-44 14-20 6-9 3-1 2 4 13 3 39 5 40 3 32 1h35l54-3 43-4 42-6 52-9 5 1 6 10 13 22 9 15 4 1v-4l19 32 12 19 15 25 17 28 10 16 2 1h264l2-1v-494h-4l-15 10-27 15-16 9-29 15 3-2 3-3v-2l15-8 27-16 14-9 10-4 8-2 10-6 10-8 1-34v-289l-5-1-1-2-2-14-4-2-34-3-59-4-8-1 1-2v-148l-1-34-14-7-5-2v-2l-6-4-9-3-8-6-18-10-16-8-29-14-21-9-3 1-3-12-13-27-4-7h6l1-1v-18l-3-16-3-7-4-2v5h-2l2-12 2-3v2h3l3 9 4 15 1 7 1 32 3 5h3l2-5 1-7v-17l-2-15-4-15-5-13-5-8 1-4h2l8 17 6 20 3 21v12l-4 20v11l5 8 7 5 29 13 27 13 22 12 17 9 11 7 5 3h3v-288l4-2 13-12 8-7 12-11 4-3 4 1 15 14 10 9 14 12 3 3 1 347 1 128 3 3 9 1 4-2 1-4v-397l-1-211-5-1h-134l-6 7-17 25-16 23-26 38-16 23-8 12-9 13-2 2 4-9 2-4-1-2-12 17-1 2-11-1-25-3-19-2-37-3-30-1h-54l-35 2-45 4-39 5-53 8h-11l-8-13-12-21-13-22-12-21h-2l2 5 10 18 11 19 10 18 4 6-1 3-3-1-2-5-14-25-16-29-14-25-16-26-25-38-2-1z"
            fill="#13226C"
          />
          <path
            transform="translate(1075,286)"
            d="m0 0h134l5 1 1 212v396l-2 5-9 1-5-2-1-2-1-128-1-347-14-13-8-7-12-11-9-8-5 1-10 10-8 7-11 10-8 7h-2v288l-4-1-11-6-13-8-29-15-15-8-28-13-15-7-6-4-5-8v-11l4-20v-12l-3-21-6-20-8-17-10-16-1-4v-7l3-8 8-11h-2-5v-42l12-17 11-16 15-22 16-23 16-24 13-18 16-24 11-15z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(239,1133)"
            d="m0 0 14 1v474l3 5 14 13 8 7 10 9 8 7 4-1 10-9 11-9 11-10 10-8 1-2 1-281 6 2 110 55 5 5 4 8-1 13-3 14-1 17 2 17 4 16 7 17 8 12 5 8 1 9-3 9-8 13v2l7-1 1 1 1 33-2 8-12 17-13 19-15 22-16 23-13 19-16 23-22 32-7 9h-135l-1-1-1-214v-230l1-103 1-69z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(618,1294)"
            d="m0 0h15l10 3 8 6 6 7 4 10 1 11-4 13-10 19-3 7 5-3 13-25 9-10 8-5 10-3h16l10 4 7 6 6 10 2 7 1 14-3 9-13 24-8 15-1 4 3-1 14-26 8-14 6-7 10-6 7-2h14l10 4 8 8 6 10 1 4-5 4-4-1-6-11-7-6-7-2-11 1-8 4-8 9-10 17-11 21-1 4 3 1 2-6 14-26 8-11 6-7 8-4h11l8 5 6 10-1 4-5 3-6-9-5-3-9 1-8 7-10 19-12 24-1 3 3-1 13-25 8-16 7-6 2-1h7l5 4 1 2v7l-11 13-9 16-11 27-10 30-10 38-6 30-5 35-19 2-29 2h-73l-33-2-35-4-26-4-1-2v-9l1-9 5 1 9 3 5 1h8l16-4h13l8 3-1-5v-9l2-14v-8l-5-25-7-28-1-6v-9l6-5 14-8 4-5 3-8-5 5-11 7-11 6-3 1-1 3v12l4 22v3h-6l-12-6-7-1 22 13 4 4-1 3-19-4h-10l-20 5-2-6v-28l3-47 1-11-4-1-3-10-8-16-3-10v-15l4-6 7-4h7l2 6-9 6-2 3v7l4 13 3 6h2l-1-6-4-10v-8l4-3h6l2 4h2l-1-10-6-17-2-9v-17l3-8 4-5 10-6 3-1h16l9 4 6 7 8 19 3 9-1 4-6 1-4-9-5-13-7-9-5-2h-10l-8 3-5 5-2 7v8l4 16 5 14 1 1 1-6-5-15-2-8v-13l5-6 6-3h11l7 6 5 11 4 12-1 5-3 2-6 1-5 3-4 4-2-1-1 2h4v3l14-8 12-5 14-3 15-31 9-12 7-6 9-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(762,439)"
            d="m0 0h96l34 2 40 4 22 3 4 2v13l-1 2-5-1-13-5h-12l-17 5-9-2-6-3-1 18-2 14v12l6 28 6 24v10l-7 7-6 4h-4l-2-9-1-1h-7l-12 5-10 5h-7l-5-5-1-3v-7l4-7 6-4-6 1-5 4-3 7 1 9 4 6 6 3 5 1h7l21-5 3 2-2 5-4 6-1 4 10-10 17-10 3-5v-12l-4-17v-7l6 1 19 9-2-4-11-6-9-7v-3l9 1 12 2 18-4h7l2 4 1 46 3-7 1-5 4 2 3 7 3 16v18l-5 1h-2l6 11 11 23 3 12v13l-2 9-5 8-7 6-5 2h-8l-1-1v-5l13-7 4-6 2-13-2-12-7-17-6-10v-3l-3 3 2 6 6 10 5 13 1 4v14l-4 8-6 4h-7l-1-3 8-10 1-2v-11l-6-15-1-4-3-1v-3h-2v4l2 1 1 5 5 10 1 10-4 6-5 1-4-7-2-6-5 6h3l6 15 4 15 1 7v10l-2 10-6 9-9 6-5 2h-14l-11-6-7-10-6-15-2-7 1-5 3-2h4l8 23 4 6 6 4 3 1h9l7-3 5-5 2-5 1-10-4-20-4-13-2-2-2 4 4 10 4 17v12l-3 6-5 4-6 2-9-1-7-8-5-13-2-11-1-3 1-3-13 4-9 2-3 5-10 22-9 15-4 5-11 7-10 3h-9l-11-2-8-4-5-4-6-10-3-9v-12l5-14 8-15 2-7h-4l-10 20-6 11-8 8-8 4-6 2h-16l-11-4-10-8-6-10-1-5v-9l3-12 7-16 13-25 2-7-3 1-15 28-8 14-8 9-8 4-7 2h-13l-10-4-7-5-4-7-2-4v-6l4-4 3 1 7 12 6 5 5 2h14l8-4 8-10 16-32 3-8v-4l-10 19-13 24-9 10-5 2h-12l-5-3-6-7-3-6 1-5h5l7 9 3 2h10l3-1 2-4 8-14 11-22 4-9v-5h-2l-2 6-14 29-7 12-5 4h-6l-4-2-5-8 1-5 10-13 8-11 3-1-3 11-7 19 3-3 8-18 11-27 1-6-3 3h-2l1-5 9-29 12-46 8-39 4-20 2-2z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(842,1625)"
            d="m0 0 10 1 10 4-3 3-10 5-4 5-1 2v11l4 6 2 1v2l4 1 16 2 3 15 5 5 7 2 14 1 13 22 17 28 5 9v3h-89l-284-1-173-1 4-8 19-28 10-15 1-1 16-3 6-4 3-5 1-9 10 2h8l8-5 4-8-1-9-4-7-7-3-7-2 4-7 6-3 9-1 9 3 10 7 4-1 6-3 4-1h9l7 3 7 5 3 4v2l-10-3-9 1-5 4-3 7 1 7 4 6 6 3-4 10v11l4 6 6 5 4 1h9l9-4 4-6 3-15 14-1 6-4 4-8-1-9-5-7-4-2-9-1v-3l10-6 3-1h8l11 4 8 5 4 1 14-8 4-1h13l15 7-1 2-10 2-7 4-4 6v9l4 6 13 5-1 13 2 7 5 5 7 3h10l8-4 4-5 2-5v-6l-3-5 1-3 11-2 6-5 2-4v-9l-4-8-8-4h-9l-9 3 3-5 9-8 5-3 4-1h8l9 2 8 6 4-2 12-7 7-2h7l10 3 10 7v2l-13 2-6 4-3 5v10l4 6 8 4 8 1 3 13 5 6 6 3 10 1 7-3 6-7 1-3v-9l-5-9 1-3 9-3 4-8v-8l-3-6-5-4-3-1h-7l-8 3-5 2 1-4 7-8 9-4 9-1 11 3 3 2 5-1 8-5z"
            fill="#DFD140"
          />
          <path
            transform="translate(862,1359)"
            d="m0 0h22l3 1 3-1h12v2h11 4l9 1 5 5 5 4 8 4 2 3 13 1 4 13 1 10-3 12-6 9-9 6-5 2h-14l-9-5-9-9-1-2-4 2-8 11-9 15-11 21-12 28-13 36-7 25-3 16v8l8 13 11 18 13 21 1 7-5-2-9-16-13-22-6-9-10 1-51 9-45 6-35 3-54 3h-35l-32-1-40-3-39-5-13-3-2-4h-2l2-5 2-3 1-13-1-26-8 1 1-4 9-16 1-10-3-8-3-5 1-4-3-1-3-5v-6l-6-14-4-19v-29l2-9 2-4h3l2 6v30l3 19 3 10 3-1-5-25-1-21 2-2 5 5 3 6 1 5v19l1-2h2l1-2v46l1 5 14-4 6-1h10l19 4-2-4-24-15v-1l8 1 12 6 6 1-5-25v-12l5-5 18-10 5-5 4-2-1 6-4 6-5 4-14 8-2 2v9l6 27 6 25 1 7v8l-2 14v14l-8-2h-13l-16 4h-8l-12-3-7-3v20l13 1 38 5 24 2 19 1h73l42-3h6l1-15 6-36 8-34 3-11 2 1-2 11-4 18 1 2 1 1 9-36 9-29 8-21 10-21 8-10 11-11 6-2-1 6-9 15-11 23-10 26-11 33-9 36-3 17v5l3-3h2l1-11 5-24 10-34 10-28 14-32 12-23 7-10 11-11 7-4h4l-2 5-7 10-12 20-11 21-12 29-11 33-7 25-6 28-1 10h3l3-13 8-34 12-36 11-30 11-25 10-19 8-12 8-11 6-7 8-5h2v-2l7-1 1 3 9-7z"
            fill="#13226C"
          />
          <path
            transform="translate(524,284)"
            d="m0 0h454l81 1-2 5-7 11-15 23-5 7-15-1-7 3-5 6-4 10h-12l-9 3-5 6-1 2v9l5 8 8 4 8 1-5 5-11 4h-7l-12-4-7-4-4 2-9 4h-10l-13-5-1-2 11-3 7-4 4-8v-7l-4-8-7-6 4-7 1-5-4-10-6-5-4-2h-13l-9 6-4 12-9 3-6 4-4 6-1 9 4 9 5 3 13 2-2 4-10 5h-14l-11-4-7-5-4 1-7 6-10 5h-17l-8-4-2-3 13-4 7-6 1-2v-10l-3-6-7-6-9-3v-14l-5-8-7-3h-8l-10 4-4 5-2 7 1 9-12 6-5 5-2 4v7l4 8 6 5 9 1 6-2 4 1-8 7-8 4-3 1h-12l-10-4-5-4-4 1-8 7-8 3h-13l-9-3-4-4 9-2 8-6 3-5v-10l-5-8-7-4-11-1-1-5-3-8-5-5-7-3-10 1-8 6-2 4v11l2 4v3l-6 4-5 6-1 4v7l4 7 5 4 4 1h9l9-4-2 4-9 8-9 3h-8l-12-5-4-1-8 7-8 3-9-1-12-6v-3l9-3 6-7 1-3v-9l-4-6-7-4-11-2-4-9-3-6-5-4-3-1-12-1-6-9-13-24-10-17z"
            fill="#DFD040"
          />
          <path
            transform="translate(924,907)"
            d="m0 0 5 1 7 3-2 10-6 29-3 21-1 9-1 36 4 1 14 7-1 3h7l16 8 10 7 10 8 5 5 10 8 10 7 3 2 3 6 7 6 8 10 4 8 5 7v2l3 1 3 4v2h2l5 10v4l4 2 5 16 5 17 5 11 3 17 1 10v33l-4 26-3 10h-2l-1 7-6 20-3 5-7 16-6 9v6l1 4-12 6-5-3-11-11-9-11-10-12-13-18-13-20-10-17-12-23-11-25-12-34-9-33-6-31-4-34-1-14v-56l3-30 5-29 7-28 3-10z"
            fill="#13226C"
          />
          <path
            transform="translate(561,365)"
            d="m0 0 3 1 13 24 11 18 10 18 10 16h11l68-10 32-4 50-4 22-1h54l30 1 50 4 12 2 24 3h6l8-12 5-7 1 4-2 2-4 9-2 5-9 13-1 42 7-2v3l-7 10-3 8v7l3 8 6 9-2 3 1 6 5 8 7 21 2 10 1 10v17l-2 10-1 2-4-1-2-4-1-32-3-16-5-13v-2h-3l-1 1-2 4v9l-2 6-1 9h-1l-1-55-1-3h-7l-20 4-19-4 3 5 13 8 6 4 1 4-23-10-3-1 3 15 2 9v12l-4 6-18 11-3 1-2 4-2 3h-2l1-6 5-7v-2l-3-1-20 5h-7l-9-3-5-5-3-6 1-9 4-6 6-4h5l-9 9-1 3v7l3 6 2 1h7l19-9 3-1h7l3 5v6l7-3 9-8v-10l-11-46-1-6v-12l3-25v-8l5 2 8 3 9-2 11-3h12l13 5 5 2v-15l-17-3-37-4-24-2-21-1h-96l-16 2-3 9-2-1-3 5-2 7-7 37-11 42-12 38-8 18-7 12-11 14-9 8h-4l1-5 11-19 7-15 10-26 10-31 8-32 7-38 2-14v-6h-4l-2 22-5 27-9 36-12 37-11 30-11 21-10 15-8 10-5 6-6 4-8 2-10 5-7 3-5 3h-4l2-5 11-14 14-22 12-22 11-25 10-27 7-21 8-32 5-26 1-8v-9l-2-2-4 28-6 27-8 26-10 29-12 29-9 20-10 18-10 14-9 11-12 12-8 4-8-1 2-4 10-9 11-14 10-16 13-25 12-28 11-28 11-34 10-41 2-11-5 1-8 39-7 25-12 34-12 29-13 28-11 19-12 17-11 11-11 7-8 3h-9l-3-1 1-3 11-7 10-8 11-11 12-18 15-29 9-19 13-33 8-24 9-34 3-17-2-1 3-13-3-1-3 21-6 26-9 29-15 41-10 23-10 19-12 18-11 14-9 9-14 9-9 4-10 1-10-2-3-3 1-3 2-1 15-2 10-4 11-8 8-10 10-15 10-17 13-26 11-27 12-36 10-40 4-17h-4l-2 13-10 40-11 33-12 28-9 20-12 21-12 17-8 10-7 7-12 7-8 2h-12l-9-3-5-5-6-8-2-5v-12l4-8 7-6 7-3h11l10 5 5 7 1 8-5 8-3 2h-8l-6-3-2-4 1-4 4-4v-2l-5 1-3 3-1 9 4 6 6 3h11l9-6 7-7 12-17 9-15 12-23 8-19 12-35 10-35 3-13v-7l-2 2-1 5-2 1v-14l-10-15-4-7 1-2h2l-2-4-12-22-12-21-9-16z"
            fill="#13226C"
          />
          <path
            transform="translate(260,1134)"
            d="m0 0h10l10 2 6 9 5 16 3 21 1 12v28l-4 26-6 37v32l4 23 9 36 6 23 1 6v19l-4 25-5 23-2 15-1 16 1 49v27l3-3 1-4v-75l5-30 6-30 2-21-1-16-4-20-10-37-3-18-1-14v-18l3-26 5-27 2-20v-38l-3-31-1-12 33 1 7 1v306l-1 161-4 5-11 9-13 12-8 7-4 2-11-10-11-9-11-10-4-3-1-210v-234z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1152,390)"
            d="m0 0 21 18 13 11 4 4 1 141 1 220v115h-12l-8-1-5-8-5-13-4-18-2-16v-28l4-37 3-26 1-13v-19l-2-21-4-19-8-26-2-10v-30l4-34 4-30 1-12v-48l-1-27v-14h-2v73l-2 28-9 54-1 10v27l4 20 7 28 4 25 1 20-2 23-5 37-1 13v46l4 32-1 11h-11l-26-2-2-2v-470l15-13 11-9z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(513,277)"
            d="m0 0h294l72 1h188l1 2-11 17-16 24-13 20-16 26-36 54-9 13-11-1-25-3-19-2-37-3-30-1h-54l-35 2-45 4-39 5-53 8h-11l-7-10-15-27-12-20-15-27-21-35-15-26-8-13-2-5zm11 7 1 5 12 21 14 25 2 2 12 1 6 3 4 5 4 11 1 1 11 2 8 5 3 5v9l-3 6-6 5-8 3 4 4 12 5 10-1 9-6 3-3 6 2 10 4h8l9-3 10-9v-3l-8 4h-9l-7-3-5-6-1-3v-7l3-7 7-6 2-1-1-5-1-2v-11l4-6 6-4 10-1 7 3 5 5 3 8 1 5 11 1 9 6 3 6v10l-4 6-7 5-9 2 4 4 9 3h13l9-4 8-7 4 1 8 5 6 2h12l9-4 8-6 2-3-6 1-9 1-7-3-6-8-1-5 1-7 3-5 10-6 5-2-1-9 3-9 5-4 8-3h8l8 4 4 7v14l9 3 8 7 2 5v10l-6 7-7 3-8 2 5 5 5 2h17l10-5 8-7 4 1 10 6 7 2h14l10-5 2-4-13-2-5-3-4-9 1-9 4-6 6-4 9-3 4-12 9-6h13l8 5 5 8 1 5-3 7-2 4 7 6 4 8v7l-4 8-9 5-9 2 3 3 11 4h10l10-5 3-1 12 6 7 2h7l11-4 5-5-11-2-6-4-4-7v-9l4-6 3-3 8-2h12l5-12 5-5 6-2 15 1 7-10 11-17 10-15 1-4-81-1z"
            fill="#020103"
          />
          <path
            transform="translate(837,1586)"
            d="m0 0 5 1 6 9 28 48 8 14 48 80 8 14 1 6h-536l-28-1 4-8 26-38 9-13 4-11 10-14 9-9 7-11 8-12 4-7 6-8 8-10 10-16 5-4 13 3 39 5 40 3 32 1h35l54-3 43-4 42-6zm5 39-11 4-8 5-5-1-7-3-7-1-10 2-8 5-6 7v3l5-2 8-3h7l6 3 4 5 1 3v8l-4 8-10 4 2 5 3 6v9l-3 6-7 6-9 1-9-3-5-4-3-6-2-10-10-2-7-4-3-5v-10l3-5 6-4 13-2-2-4-11-6-7-2h-7l-11 4-10 7-4-2-6-4-9-2h-8l-7 3-8 6-6 7 2 1 7-3h9l8 4 4 8v9l-4 6-7 4-8 1v4l2 4v6l-4 8-5 4-5 2h-10l-9-4-4-6-1-9 1-9-13-5-4-6v-9l5-7 8-4 8-1v-3l-14-6h-13l-10 4-8 5-4-1-8-5-11-4h-8l-10 5-3 2v3l9 1 6 4 3 5 1 9-4 8-6 4-14 1-3 15-4 6-9 4h-9l-7-3-6-7-1-2v-11l4-8-1-3-5-2-4-6-1-7 4-8 7-4 10 1 6 2-2-4-5-5-6-4-4-1h-9l-8 3-3 2-4-1-11-7-7-2-9 1-7 4-3 6 7 2 8 4 4 9-1 9-4 6-7 4h-8l-10-2-1 9-4 6-8 4-13 2-7 10-22 33-5 8v1l457 2h89l-1-5-19-32-15-25-14-1-9-3-3-4-3-15-16-2-4-1v-2l-5-5-1-2v-11l4-6 8-5 6-3-2-2-8-3z"
            fill="#020103"
          />
          <path
            transform="translate(386,326)"
            d="m0 0 10 3 16 8 17 10 13 9 11 9 25 25 8 14 3 5 6 18 1 4 1 21-2 11-4 10-7 9-8 6-7 3-16 4-18 2h-36v30l39 1v9l-1 8-65 1-35-1v-17l40-1 1-31-9 1h-30l-22-3-16-5-9-6-7-8-5-12-2-8v-18l5-21 10-19 11-15 4-4h2l2-4 10-9 11-9 11-8 22-13 16-8z"
            fill="#020103"
          />
          <path
            transform="translate(1055,1490)"
            d="m0 0h16l45 1 1 1v9l-1 7-38 1v30h29l18 1 20 4 12 5 5 4 8 10 4 9 2 13-1 18-4 15-6 14-6 10-14 17-8 8-14 11-13 10-23 13-20 10-5-2-28-14-18-12-11-8-28-28-10-16-5-11-5-21v-15l3-14 7-13 7-7 12-5 16-4 16-2h22l17 1v-31h-13l-28-1v-17z"
            fill="#020103"
          />
          <path
            transform="translate(428,671)"
            d="m0 0 3 1-8 5-2 2 9 11 11 14 14 19 12 17 14 24 10 18 9 17 14 32 10 28 9 32 6 29 4 30 2 26v42l-3 32-5 29-6 27-5 17-4-1-5-3 5-25 4-24 3-28 1-14v-32l-2-33-5-37-6-29-8-29-9-26-12-29-15-31-13-23-1-3-4-2 1 3 5 11 7 13-2 20v29l3 16 6 16 8 15 12 17 9 10 7 8 7 6 1 2 1 17-5-2-12-8-17-16-10-12-3-4-3 3 1 4-14 11-7 8-1 3v7l4 6 5 4h8l11-4 13-9 6-3 2 2-1 4-10 11-10 7-12 6h-3l-1 4 9-2 2-3 4 2 1 2 3-1 2-5 11-13 8-7 5 1-2 5-10 11-2 4v12l5 8 5 3h12l7-4h4v9l-5 5-9 6-6 1v2l-7 2 2 2h7l16-10h3v21l-6-1-14-6-12-4-18-11-10-8-12-9-8-7 2-4h2l-4-4-10-5-5-6-1-3v-12l5-10 3-4-2-1h3l-1-2h-6l-2 1 4 2v2h-2l-2 6-6 9h-3l-10-14-3-3-7-11-6-10-8-20-2-10-2-7-3-10-2-30v-13l1-3v-15l4-21 5-17 4-13 5-12 3-10 8-14 1-4-4-5v-2l-18 4-3 2-10 3-2 2-10 4-17 8-2-1 19-10 27-13 25-11z"
            fill="#13226B"
          />
          <path
            transform="translate(940,913)"
            d="m0 0 13 5 37 17 14 7 1 2 4 32 5 28 4 17 7 25 7 20 11 28 13 25 12 19 13 18 11 14 12 14 25 25 11 9 13 11 15 11 20 14 6 4v4l-13 8-19 12-26 15-28 15-30 15-24 10-8 1-2-3 1-7 10-19 7-15 7-19 5-21 2-14 1-30-3-25-3-16-7-21-8-16-9-17-7-10-8-11-12-14-19-19-14-11-15-11-17-11-23-12-5-2v-20l3-31 4-28 4-18z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(399,689)"
            d="m0 0h6l5 7-1 4-9 16-10 24-6 19-4 18-3 21-1 25 3 23 6 26 6 16 8 15 7 14 10 14 11 14 9 10 13 13 11 9 17 13 24 15 25 13 1 1v13l-4 37-5 29-4 19-7-1-53-24-1-1-4-44-5-28-7-25-10-28-7-15-5-10-3-5-13-24-12-16-7-11-9-11-12-14-14-15-28-28-11-9-10-8-18-13-14-10-5-4 2-4 20-14 24-16 19-12 18-10 24-13 28-13z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(107,50)"
            d="m0 0h1240l17 1 12 4 10 6 10 10 6 11 3 8 1 5v1845l-3 12-5 10-9 10-9 7-12 5-4 1-13 1h-1250l-16-2-9-4-11-7-8-9-6-11-3-9-1-10v-1828l2-18 8-16 6-7 11-8 12-5 5-1zm-13 3-10 2-12 6-10 9-8 13-3 8-1 6v1840l3 14 6 11 9 10 11 7 7 3 7 1h1267l12-3 11-6 9-8 8-13 3-11 1-15v-1820l-1-14-4-12-7-10-9-9-14-7-9-2z"
            fill="#101C58"
          />
          <path
            transform="translate(301,982)"
            d="m0 0h19l10 3 8 7 7 14 5 16 5 27 1 9v16l-4 13-7 8-12 6-19 3h-10l-32-3-2-1v-2l-6-1-9-4-8-4-3-4-1-5 3-7 6-4 1-5-11-2-2-2-1-5 3-7 8-7 4-2 2-5h-7l-5-4-1-8 5-6 5-1 2-5 3-3-8-1-2-3v-5l7-6 5-2h8l6 3 5-1 5-3 8-5z"
            fill="#13226C"
          />
          <path
            transform="translate(1125,929)"
            d="m0 0h17l33 2 4 2 3 8 7 1 5-1 6 4 3 6v7l-4 6-3 3v4l8 2 3 4v6l-6 9-5 2v6h2l6 7-1 5-5 5-5 3h-2l-1 4h2v2l5 1 1 6-6 7-5 2h-15l-13 5-10 3-12 1-16-3-8-5-4-5-8-21-7-25-4-23v-14l3-7 6-7 11-7 11-4z"
            fill="#13226C"
          />
          <path
            transform="translate(538,673)"
            d="m0 0 16 2 12-1h31l10 19 13 30 10 26 7 20 8 26 6 22 6 26 5 28 6 48v5l-1 1h-31l-2-5-5-30-7-30-9-31-6-18-11-28-7-17-15-30-14-25-12-19-10-16z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(797,1107)"
            d="m0 0h16l5 2 4 21 6 29 8 31 12 36 10 25 12 27 13 26 11 20 10 17 8 13 1 4-8-1-6-2h-9l-11 2-15 1-7 1-3-5-12-24-13-30-9-24-11-33-8-30-7-33-6-38-3-27v-6l1-1z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(91,95)"
            d="m0 0h29l1 1v54l14-19 8-11 13-18 3-4 1-3h35l-2 5-7 10-11 15-7 10-8 11-6 9-8 11h-2l3 7 12 19 10 16 11 17 13 21 8 12-1 2h-31l-5-5-15-23-13-21-9-14-5-8-1 70-1 1h-27l-2-5z"
            fill="#020207"
          />
          <path
            transform="translate(1277,1776)"
            d="m0 0h8l5 5 11 17 15 24 13 21 3 4 1-71h28l1 1v164h-29v-53l1-2h-2l-2 4-9 12-7 10-10 14-9 12-2 3h-34l2-5 10-14 14-20 9-12 7-10 8-11-2-6-13-20-15-24-12-19-9-14-5-7v-2z"
            fill="#020104"
          />
          <path
            transform="translate(760,1089)"
            d="m0 0h69l2 9 4 28 6 30 6 24 9 29 8 21 11 25 11 22 13 22 12 19 8 12 12 17 10 13 9 11v3h-5l-10-9-14-7-10-13-12-19-9-16-12-23-10-21-5-11-11-28-10-29-9-31-5-22-5-27-2-13-41-1 4 43 5 33 7 32 9 32 13 38 13 32 12 26 8 16 2 5-12 3-10 1-11-23-10-23-6-13-13-34-8-24-9-36-6-31-5-37-4-48v-6z"
            fill="#DFD040"
          />
          <path
            transform="translate(503,654)"
            d="m0 0 6 5 5 6 14 8 8 8 12 17 13 21 13 24 8 16 10 21 11 28 11 33 10 40 6 35 2 12 39 1-4-47-5-33-7-35-8-30-12-36-14-34-13-27-6-14 1-2 8-3h6l8 16 11 23 10 26 13 38 10 37 8 37 5 31 3 30 1 17v20h-66l-7-46-7-31-8-29-9-26-12-29-8-18-8-16-13-23-13-21-10-15-14-19-7-10-2-5z"
            fill="#DFCF40"
          />
          <path
            transform="translate(924,907)"
            d="m0 0 5 1 7 3-2 10-6 29-3 21-2 21v58l3 30 5 29 6 27 10 35 11 30 13 29 12 24 14 24 16 24 24 30 6 6-1 4-11 5-5-3-11-11-9-11-10-12-13-18-13-20-10-17-12-23-11-25-12-34-9-33-6-31-4-34-1-14v-56l3-30 5-29 7-28 3-10z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(397,721)"
            d="m0 0 1 3-8 20-8 32-2 11v15l-1 3v13l2 30 4 16 2 6 4 13 6 13 9 16 3 4v2l3 1 10 14 4-4 6-11h2l-1-2-4-2 3-2h8l-3 7-5 8-1 3v12l3 6 9 6 7 4v2l-3 3 5 5 8 7 14 10 10 7 12 7 12 4 14 6 4 1v-21l-11 6-8 5h-7l-3-3 3-2h5v-2l10-4 8-6 1-2 1-9-8 3-3 2h-12l-8-6-3-6v-12l4-6 9-10 1-4-5 1-8 7-11 14-4 4-3-4h-2l-2 3-6 2h-7l1-3h4v-2l12-5 10-7 9-8 4-5-1-4-9 5-10 7-11 4h-8l-8-7-2-4v-7l3-6 8-8 11-8v-3l-3-2h5l1-4 9 12 11 12 11 10 16 10-1-4-1-13-5-6-8-7-12-14-12-18-8-16-5-13-3-16v-29l2-20-8-14-6-15 6 4 12 21 14 27 12 28 10 27 8 26 7 30 5 31 3 29 1 21v32l-3 33-4 27h-1v-12l1-1 1-10v-22l1-11v-13l-27-14-22-14-17-13-15-13-17-17-13-17-8-11-8-14-8-16-6-15-5-19-4-25-1-14 1-19 4-27 6-22 7-19z"
            fill="#13226C"
          />
          <path
            transform="translate(721,952)"
            d="m0 0 9 1 9 7 10 10 9 13 5 12 3 11 1 14-3 16-5 12-7 12-11 12-9 8-6 3-7-1-11-9-9-9-9-14-5-12-2-7-1-8v-9l3-16 9-19 8-11 7-8 8-6z"
            fill="#DFCE40"
          />
          <path
            transform="translate(907,730)"
            d="m0 0 9 2 7 3-1 4-7 11-11 17-15 25-12 23-12 26-10 27-8 24-9 34-4 17-1 1h-65l1-9 8-44 11-44 12-36 10-26 16-35 4-6 15-4 4-1-10 24-12 29-14 38-10 30-9 36-4 23-1 9h30l3-7 9-34 12-35 13-32 16-33 10-18 13-21 10-14z"
            fill="#DFCF40"
          />
          <path
            transform="translate(143,297)"
            d="m0 0h6l19 10 10 7 13 13 8 15 2 8v14l-5 10-8 5-17 3h-19l1 15h18v10h-49l-1-1v-6l3-3h15l2-1v-13l-21-1-15-3-7-4-4-7-2-5v-14l4-12 6-9 17-17 16-10z"
            fill="#020104"
          />
          <path
            transform="translate(1282,1630)"
            d="m0 0h51l-1 8-3 1h-16v15h18l15 2 8 4 6 7 2 6v12l-4 14-6 9-17 17-18 11-8 4-4-1-19-10-10-7-14-14-8-16-2-14 2-9 3-6 9-6 7-2 9-1h20v-14l-18-1-2-1z"
            fill="#020104"
          />
          <path
            transform="translate(616,1088)"
            d="m0 0h50l13 1-2 13-8 41-11 44-10 32-10 27-16 35-4 10-12 4h-4l2-6 17-38 13-33 12-37 8-30 6-31 3-16h-32l-1 7-8 29-14 41-13 32-17 35-10 18-11 18-11 17-9-2-10-3 2-5 13-20 14-24 10-18 9-17 12-27 8-20 9-27 7-28 4-20z"
            fill="#DFD040"
          />
          <path
            transform="translate(685,449)"
            d="m0 0 3 3v12l-4 25-7 30-8 27-12 32-9 20-8 16-9 16-14 21-10 13-1 2 4 1-16 5-5 2-23 1-12 1-7-3-7-2-1-1-8 1-1 1-7-1-10-6-1-3-3-1-6-8-7-3h-1l-2-6-4-11v-12l4-9 4-5 10-6 4-1h14l8 4 7 7 4 8 2 1 2-4 14-21 10-17 8-17 10-26 10-30 8-32 3-4v-5l4-2v8l-7 28-12 38-9 25-15 31-14 23-11 14-8 8-7 4h-11l-8-5-3-5 1-9 5-5 5 1-2 4-3 3 1 7 6 2h8l5-5 2-4-1-8-5-7-9-4h-11l-10 5-6 8-1 3v12l5 10 4 5 8 4 4 1h12l10-3 11-7 8-8 13-18 12-20 8-16 12-27 10-26 8-26 9-37 2-9h4l-2 12-9 38-9 29-11 29-9 20-11 22-13 21-9 12-7 8-11 7-8 3-15 2-2 1 2 4 10 2 10-1 16-8 10-8 7-7 12-16 11-18 11-21 11-28 13-36 8-27 5-22 4-21 4 1-3 13 1 1-1 11-6 26-10 33-13 33-9 20-13 26-9 15-9 12-13 13-10 7-8 5-1 2h12l10-4 11-8 9-9 14-21 13-24 12-27 13-34 11-33 7-30 4-21 2-2 4 1-1 11-11 44-12 36-11 28-13 29-12 23-11 16-12 14-8 7-1 2h8l8-4 14-14 12-16 8-13 10-19 15-36 9-25 10-31 6-26 4-24z"
            fill="#06137F"
          />
          <path
            transform="translate(641,1107)"
            d="m0 0h9l7 1-1 13-6 31-8 29-11 32-10 25-11 26-24 51-12 21-5 6-5-1-6-18-8-15-2-3 1-4 10-14 11-18 11-19 12-23 13-29 13-34 9-27 7-28z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(1150,382)"
            d="m0 0 4 1 15 14 10 9 14 12 4 4 1 347 1 130-5-1-2 1-1-115-1-220-1-141-7-7-11-9-15-13-4-3-13 11-11 9-13 11-1 326-2-1v-34l-5-1-14-8v-2l-4-2-11-4-8-6-18-10-16-8-29-14-23-10v13h-1l-2-17-5-14-10-20-3-4v-3l6-1v-18l-3-16-3-7-3-2v5h-2v-8l1-5 1-2h2v2h3l6 15 3 16 1 32 2 4 3 1 2-12v-17l-2-15-4-15-5-13-5-8v-5l3-1 5 8 6 14 5 17 3 21v12l-4 20v11l5 8 9 5 30 14 23 11 22 12 17 9 11 7 8 4v-288l11-9 16-15 8-7z"
            fill="#13226C"
          />
          <path
            transform="translate(419,681)"
            d="m0 0 4 1 12 14 9 12 14 19 10 15 13 22 10 18 9 17 14 32 10 28 9 32 6 29 4 30 2 26v42l-3 32-5 29-6 27-5 17-4-1-5-3 5-25 4-24 3-28 1-14v-32l-2-33-5-37-6-29-8-29-9-26-12-29-15-31-13-23-15-24-12-17-16-21-7-9 1-3z"
            fill="#FCFCFC"
          />
          <path
            transform="translate(398,1106)"
            d="m0 0 5 1 30 14 1 3-15 30-7 12-6 11-10 16-13 19-8 10-9 11-15 16-5 5h-2v-81l1-34 16-3 15-4 11-7 6-8z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(1105,782)"
            d="m0 0h3l1 34v77l-1 2-3 1-20 2-12 4-11 7-7 10-3 6-9-3-23-11 1-7 8-18 12-23 9-15 13-18 10-13 12-14 7-8z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(885,691)"
            d="m0 0 2 1 6 15 8 15 3 3-1 5-11 15-13 20-11 19-15 30-12 29-10 28-9 31-5 22-4 2h-17l-3-3 6-28 9-36 12-37 12-31 11-25 12-25 12-23 11-17 6-9z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(241,785)"
            d="m0 0 7 1 19 12 16 11 13 10 12 10 8 7 10 9 10 10 7 8 7 7 11 14 10 13v2h2l21 35 9 17 10 24 10 30 6 27 4 28 1 10v11l-5-1-27-12-5-3-1-4v-9h8l3 13h12l3-2-4-33-2 1-11 1h-13l-5-18 1-2 7-1 3 9v3l18-3-6-21-3-11-24 7-4-4-5-13v-5l4-2 5 1 4 9v2l16-4-5-13-8-17-3-1-17 8-5 1-6-9-5-9 1-4 5-2h4l5 9v2l12-5h3l-7-14-10-15h-3l-17 9-5-1-7-9-2-5 5-4 4 2 6 5 10-6h2l-7-10-9-11-2-3-6 1-12 9-6 3-14-14-1-4 6-4 4 1 6 5 5-1 8-6-2-4-19-19-4 1-14 12-3 3-4-2-11-9v-4l3-4h6l4 3 5-1 5-5h2l-3-5-12-10-8-6-5 1-14 14-3 1-17-10-1-1v-8l6 1 10 4 4-1 4-7h2v-5l-25-15 1-4z"
            fill="#DECC3F"
          />
          <path
            transform="translate(1064,969)"
            d="m0 0 6 2 8 5 7 33 6 21 10 26 8 17 11 20 10 15 12 16 11 13 7 8 15 15 8 7 10 9 19 14 3 3v9l-5-2-11-8-4 1-17 17-5-2-12-10 2-4 5-2 7 4 4-1 8-9-5-6-14-11-4-2-9 7-10 8-4-1-9-9-4-5 1-4 5-1 9 8 5-2 8-7-6-8-14-14-6 1-15 11-4-2-9-12-2-5 4-2 4 1 5 7 14-7-2-6-10-14-4-4-20 10-4-1-10-17 1-4 3-1 4 1 5 8 3 1 12-5-13-26v-2l-23 6-4-1-7-17 1-4 5-2 3 4 3 9 14-4h3l-11-29-2-1-23 6-3-8-3-10v-5l7-1 3 7 1 3 17-1-6-28-2-1-17 2h-7l-4-17v-6h8l2 10v2l17-1z"
            fill="#DFCD3F"
          />
          <path
            transform="translate(107,50)"
            d="m0 0h1240l17 1 12 4 10 6 10 10 6 11 3 8v1449h-1l-1-90v-1342l-1-14-4-12-7-10-8-8-14-7-9-2h-1266l-10 2-12 6-9 8-8 13-3 8-1 6-1 342-1 29h-1v-375l3-10 7-12 5-6 11-8 12-5 5-1z"
            fill="#111E5E"
          />
          <path
            transform="translate(1023,951)"
            d="m0 0 10 4 20 9 6 3v14h-8l-3-12h-16l4 29 1 3 17-2h10l2 5 2 14-8 3-4-6-2-5-16 2 10 30 7-1 14-4h5l6 16v5l-7 2-3-5-3-6-12 3h-3l4 13 7 17 2 1 20-6h6l8 16v4l-4 2-4-1-6-9-10 3-4 2 1 4 14 22v2l6-1 18-8 4 2 7 11-1 4-4 2-5-1-3-4v-2l-8 2-6 4 6 9 11 14 5 1 16-11 4 1 11 12 1 4-4 3-5-1-5-5h-5l-7 6 1 4 9 10 10 10 3 1 5-4 4-4 10-8 4 2 10 9v5l-3 1-9-4-4 2-7 7-1 4 11 9 9 7 5 1 15-15 2-3 4 1 14 9 1 2v8l-6-2-10-4-7 10-1 4 14 10 9 7 1 1v6l-6-2-22-13-16-11-10-8-11-9-10-9-8-7-15-15-7-8-10-12-12-16-9-13-11-19-12-23-13-32-9-30-7-33-4-31z"
            fill="#DECC3F"
          />
          <path
            transform="translate(276,823)"
            d="m0 0 5 2 11 9v4l-5 1-6-4-4 1-10 10 2 4 11 10 8 6 2 1 2-4 15-13 4 1 13 13-1 4-5 1-6-6-6 1-9 8 2 4 11 12 7 8 4-2 5-2v-2l10-6 1-2 5 1 10 12 2 2v2l-4 2-5-1-5-5-6 2-6 4h-2l1 4 10 13 5 7 6-2 15-8 5 1 9 15 1 4-7 2-4-5-3-4-6 2-9 5 2 6 9 16 2 6 16-6 7-3h4l7 16 1 5-5 3-3-1-5-10-8 1-5 2h-3l9 27 1 2 8-1 13-4h5l5 19v2l-4 2h-4l-3-10-10 1-5 1 2 12 3 14v3l26-1 2 11 1 12-7 1-2-6-1-8h-16l1 14-2 1-8-4-4-15-5-21-10-30-11-24-11-21-8-12-12-16-11-14-11-13-14-14-3-2v-2l-4-2-13-12-18-13-9-7-1-2v-8l5 1 13 8 4-1 1-2h2v-2l7-5 5-5z"
            fill="#DECC3F"
          />
          <path
            transform="translate(406,760)"
            d="m0 0h14l25 5 3 2-1 4h-8l-12-2h-9l-9 4-4 4-1 9 4 8 10 5 19 3 5 2-1 3-3 1h-38v2l-11 6-3 3 7-2 10-4 16-2h14l7 1 2 2v3l-2 1-18 1-10 3-7 5-2 3v8l3 5 7 4 11 2h22v4l-9 3-6 1-1 2 9-2h9l1 4-7 3-11 4-9 6-4 6v8l4 6 5 3 5 1h11l10-3 10-5 3 1-1 3-10 7-15 8-6 2h-18l-10-4-8-7-5-10-6-15-2-10-2-7-3-10-2-30v-13l1-3v-15l2-10 3-1 1-5 7-6 10-4z"
            fill="#13226D"
          />
          <path
            transform="translate(960,559)"
            d="m0 0 4 2 3 7 3 16v18l-5 1h-2l6 11 11 23 3 12v13l-2 9-5 8-7 6-5 2h-8l-1-1v-5l13-7 4-6 2-13-2-12-7-17-6-10v-3l-3 3 2 6 6 10 5 13 1 4v14l-4 8-6 4h-7l-1-3 8-10 1-2v-11l-6-15-1-4-3-1v-3h-2v4l2 1 1 5 5 10 1 10-4 6-5 1-4-7-2-6-5 6h3l6 15 4 15 1 7v10l-2 10-6 9-9 6-5 2h-14l-11-6-7-10-6-15-2-7 1-5 3-2h4l8 23 4 6 6 4 3 1h9l7-3 5-5 2-5 1-10-4-20-4-13-2-2-2 4 4 10 4 17v12l-3 6-5 4-6 2-9-1-7-8-5-13-2-11-1-7 13-7 12-11 7-7 9-14 5-12 4-16 2-12 1-13 2-13 3-7z"
            fill="#13226C"
          />
          <path
            transform="translate(1125,929)"
            d="m0 0h17l9 1 2 2 3 7 4 3 9 1 12-1-3 5-7 4-5 1h-10l-12-1-5 6-8 5-10 3 8 6 4 5-1 8-6 11-1 4 6 4 4 8 1 19 8-6h6l5 5 5 10 3 3v3l-10 4-16 2-16-3-8-5-4-5-8-21-7-25-4-23v-14l3-7 6-7 11-7 11-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(301,982)"
            d="m0 0h19l10 3 8 7 7 14 5 16 5 27 1 9v16l-4 13-7 8-12 6-19 3h-10l-8-1-5-8-8-3-14-1 2-4 10-4h21l11-6 10-4 9-2-12-6-3-4v-8l4-10 1-1v-5l-5-5-4-13-1-13-7 5-6-1-5-5-4-9-6-4 1-4 10-5z"
            fill="#FCFCFC"
          />
          <path
            transform="translate(48,102)"
            d="m0 0h1v337h1v1474l-1 19-2 2v-1828z"
            fill="#14236C"
          />
          <path
            transform="translate(926,1375)"
            d="m0 0h10l10 4 8 6 4 9v11l-4 10-8 7-7 3h-12l-7-3-5-5-3-6v-7l4-7 8-4 9 1 4 4 1 7v2l4 1 1-7-3-7-5-4-2-1h-11l-10 5-12 17-16 23-10 18-11 25-11 30-10 33-6 25-2 7-6 2h-5v-9l7-33 8-27 10-29 13-29 12-22 13-19 12-14 11-10 10-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(626,457)"
            d="m0 0 5 1-3 17-9 35-11 33-12 28-9 20-12 21-12 17-8 10-7 7-12 7-8 2h-12l-9-3-5-5-6-8-2-5v-12l4-8 7-6 7-3h11l10 5 5 7 1 8-5 8-3 2h-8l-6-3-2-4 1-4 4-4v-2l-5 1-3 3-1 9 4 6 6 3h11l9-6 7-7 12-17 9-15 12-23 8-19 12-35 10-35 5-23 3-2z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(729,738)"
            d="m0 0h8l8 4 5 6 1 2v10l-3 8 10-4h7l6 3 5 5 3 7-1 6-4 6-5 4-5 2h-8l-6-3 1 6v10l-3 5-8 6-7 1-9-3-5-3-3-6v-12l1-3-4 1h-11l-10-5-4-7 1-9 4-6 5-4 3-1h10l7 3-2-6v-9l3-7 7-6z"
            fill="#DFD040"
          />
          <path
            transform="translate(365,1084)"
            d="m0 0h12l8 4 6 8 2 5v10l-4 8-5 5-9 6-7 3-10 2h-17l-51-3-37-4-14-2-1-1v-13l1-6 44 2 46 3h23v-11l3-8 8-7z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1111,898)"
            d="m0 0 21 1 47 3 34 3 1 1v20h-16l-47-4h-58l2 5-1 10-3 5-6 5-2 1h-15l-9-5-4-7v-9l4-9 7-8 10-6 11-4 6-1z"
            fill="#DFD141"
          />
          <path
            transform="translate(712,1210)"
            d="m0 0 8 2 6 4 3 5 1 6v10l4-1h13l9 6 2 5v9l-4 6-6 3h-16v14l-4 8-6 5-6 2-7-1-7-4-4-6-1-3v-9l2-6-6 1h-10l-6-3-5-6-1-2v-8l4-6 6-4h12l5 1-2-7 1-9 4-6 5-4z"
            fill="#DFD040"
          />
          <path
            transform="translate(832,1367)"
            d="m0 0h7l-12 9-9 12-10 15-13 25-11 27-13 36-8 26-7 30-3 13-2 2-1-1-2 3v-8l5-26 9-33 12-36 13-30 14-26 9-14 7-10 1-2-8 3-10 9-7 8-14 26-13 29-10 27-9 29-6 24-4 22-4 3-1 5h-1v-10l5-25 7-28 12-36 11-27 11-23 8-13 1-4-8 5-11 11-7 11-8 17-9 24-8 26-9 36-4 1 1-10 5-21 1-10 11-33 11-26 8-14 11-13v-7l-5-5h-7l-8 6-8 16-13 25-2 2-3-1 11-23 11-22 8-8 6-2 7 1 5 4 5 7 4-3-1-5-6-9-6-3h-11l-8 4-9 11-9 15-12 23-4-1 4-10 10-19 10-16 7-7 8-4 11-1 9 3 7 7 5 10 5-1 8-5 13-8 10-3z"
            fill="#071580"
          />
          <path
            transform="translate(519,1303)"
            d="m0 0h16l9 4 6 7 8 19 3 9-1 4-6 1-4-9-5-13-7-9-5-2h-10l-8 3-5 5-2 7v8l4 16 5 14 1 1 1-6-5-15-2-8v-13l5-6 6-3h11l7 6 5 11 4 12-1 5-3 2-6 1-5 3-4 4-2-1-1 2h4l1 4-6 5-9 11-8 13-6 15-3 10h-5l-3-9-8-15-4-13v-15l4-6 7-4h7l2 6-9 6-2 3v7l4 13 3 6h2l-1-6-4-10v-8l4-3h6l2 4h2l-1-10-6-17-2-9v-17l3-8 4-5 10-6z"
            fill="#12216E"
          />
          <path
            transform="translate(270,1134)"
            d="m0 0h39l17 3 11 1 2 2v121h-1v-120l-32-1-8-1 3 20 2 23v38l-3 26-5 28-2 19v18l2 21 5 23 8 29 3 16 1 16-2 21-9 46-2 14v75l-3 7h-2l-2-63v-13l2-24 5-26 4-21 1-8v-19l-4-18-11-42-4-21-1-7v-32l6-37 4-26v-28l-3-28-4-16-6-12-3-2-8-1z"
            fill="#13226C"
          />
          <path
            transform="translate(788,391)"
            d="m0 0 5 2 10 7 15 7 9 3 8 2h13l15-2 16-6 15-8 3-1 8 7 11 8 14 6 7 2 15 1 15-1 1 4-5 7h-11l-38-6-33-3-31-2h-57l-35 2-22 2-30 2-50 6h-12l3-3 16-8 11-9 5-6 6 1 15 6 17 5h22l18-4 14-7 10-8z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(804,476)"
            d="m0 0h15l13 4 9 8 9-1 1 2-6 8-1 3 5 5-1 7-2 6-9 9-16 11-14 7-3-1 2-4 19-11 7-7-5 1-16 3-17-3-24-9h-14l-8-4 1-5 7-7 16-10 15-7z"
            fill="#13226C"
          />
          <path
            transform="translate(466,898)"
            d="m0 0 5 1-1 4-13 10-7 8-1 3v7l4 6 5 4h8l11-4 13-9 6-3 2 2-1 4-10 11-10 7-12 6h-3l-1 4 9-2 2-3 4 2 1 2 3-1 2-5 11-13 8-7 5 1-2 5-10 11-2 4v12l5 8 5 3h12l7-4h4v9l-5 5-9 6-6 1v2l-7 2 2 2h7l16-10h3v21l-6-1-14-6-12-4-18-11-10-8-12-9-8-7 2-4h2l-4-4-10-5-5-6-1-3v-12l5-10 7-7 13-9z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(639,1490)"
            d="m0 0 3 1-5 5-14 9-2 3 9-2h18l16 5 18 7 9-1 7 4 6 1-2 4-13 10-21 11-15 5-12 2-14-1-9-3-9-6-12 1 1-4 7-8-1-4-3-6 4-8 9-10 12-9z"
            fill="#13226C"
          />
          <path
            transform="translate(1154,449)"
            d="m0 0h2l1 14 1 27v48l-3 28-5 38-1 10v30l5 21 6 18 4 24 1 13v19l-3 32-4 32-1 12v28l3 22 6 21 6 11 20 2v1l-6 1 1 2-22-1-45-3-9-1 1-3v-50l1-97h1l1 144 1 1 37 3v-11l-4-32v-46l3-29 4-31 1-20-2-21-5-26-8-32-1-7v-27l3-22 6-34 2-17 1-19z"
            fill="#13226C"
          />
          <path
            transform="translate(783,372)"
            d="m0 0 4 1 8 8 13 9 10 6 11 4 5 1h22l14-5 14-9 10-9 4-4h2l5 10 7 9 9 8 12 5 15 2 13-1 12-3 4-2 3 1-8 10-12 3h-19l-15-4-11-6-13-11-4-4-4 1-13 8-16 7-15 3h-12l-14-3-12-5-14-8-9-7-7 6-8 7-14 8-17 5-8 1h-11l-16-3-17-6-10-5h-3l-7 8-9 8-15 8-8 2h-20l-15-4-5-5-3-4v-2l10 3 12 3h19l13-4 8-5 5-5 4-5 8-16 5 5 8 7 14 7 13 3h20l15-3 14-7 10-8 7-10z"
            fill="#DFD040"
          />
          <path
            transform="translate(453,752)"
            d="m0 0 6 4 12 21 14 27 12 28 10 27 8 26 7 30 3 17v12l-3-4-1-7h-2l-1-13-5-6-8-7-12-14-12-18-8-16-5-13-3-16v-29l2-20-8-14-4-10z"
            fill="#13226C"
          />
          <path
            transform="translate(1072,693)"
            d="m0 0 4 1 9 5-5 5-15 13-8 7-24 24-7 8-9 11-12 16-12 17-15 24-8 14-8 16-11 23-3 1-13-6-1-3 12-23 14-24 11-18 11-16 9-12 10-13 12-14 12-13 18-18 8-7 14-12z"
            fill="#DFD040"
          />
          <path
            transform="translate(766,985)"
            d="m0 0 62 1v18l-1 27-1 12-1 1h-31l-26-1 1-9 1-4v-23l-3-14z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(642,454)"
            d="m0 0h7l-3 21-6 26-9 29-15 41-10 23-10 19-12 18-11 14-9 9-14 9-9 4-10 1-10-2-3-3 1-3 2-1 15-2 10-4 11-8 8-10 10-15 10-17 13-26 11-27 12-36 10-40 4-17z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(516,1301)"
            d="m0 0h14l5 1v1l-16 1-10 5-3 1-2 4-3 5-1 4v17l4 16 4 10v10h-2l-2-3h-6l-3 2v8l5 12-1 5-3-1-6-14-1-5v-7l5-6 6-3-1-5h-7l-8 5-2 4v15l5 15 7 13 2 8h4l-2 25-1 16h-2l-1 4h-2l-1-19-3-10-5-5-1 1 1 21 4 22v3h-2l-1 2-3-7-3-14-1-9v-30l-1-6h-3l-3 13v29l4 19 6 14v6l3 5 2 1 1 4h-3l-8-13-6-15-5-21-1-19 2-16 3-14v-7l-5-11v-22l3-8 6-8 10-6 13-2v-23l5-9 8-6z"
            fill="#08157F"
          />
          <path
            transform="translate(624,987)"
            d="m0 0h59l1 2-4 15v25l2 13-2 2h-29l-28-1-1-1 1-54z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(723,444)"
            d="m0 0h1l-1 14-5 30-6 27-7 27-12 35-10 24-8 15-7 12-1 3 7-3 7-7 13-18 9-19 11-33 10-36 6-26 6-33 3-3 2-5h1v9l-7 36-12 48-11 36-2 5h2l1-3 3-1-1 7-11 27-9 20-3 1 2-9 8-21-5 5-14 19-2 3 1 5 3 4v2l10 1 5-4 15-29 8-17 3-1v6l-16 33-7 12-6 6h-10l-5-4-5-7h-5l1 7 6 8 3 3 3 1h12l6-3 7-8 15-28 8-15 2-1-1 8-5 11-9 19-7 11-6 7-8 4h-14l-8-4-6-7-5-9-5 1v8l2 4-1 3-3-4-2-6-6-4 6-9 7-10 9-15 8-17 15-43 9-30 8-34 4-26 2-14z"
            fill="#061382"
          />
          <path
            transform="translate(1009,945)"
            d="m0 0 5 1 4 3 6 43 6 29 9 30 7 19 12 26 11 21 11 17 10 14 11 14 11 13 7 7 7 8 8 8 8 7 15 13 11 9 14 10 19 12 4 2-2 4-1 1-7-1-17-11-18-13-17-14-12-11-8-7-12-12-7-8-9-10-13-17-11-15-11-18-10-18-8-16-12-29-8-25-7-28-4-26-2-17z"
            fill="#DECC3F"
          />
          <path
            transform="translate(502,1155)"
            d="m0 0 6 1 5 2-1 6-10 24-13 25-15 23-13 19-10 13-18 22-28 30-11 11-8 7-4 3-12-7-1-3 5-5 10-9 8-7 28-28 7-8 10-12 11-14 12-17 12-18 11-18 9-17z"
            fill="#DFCF40"
          />
          <path
            transform="translate(910,1364)"
            d="m0 0h17l5 4v2l-18 5-11 6-12 11-8 9-10 15-9 15-14 29-10 25-10 31-9 36-4 22-3 2-11 2-1-3 6-28 10-36 12-35 11-27 9-20 12-21 8-12 9-11 12-12 10-6z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(721,952)"
            d="m0 0 9 1 9 7 10 10 9 13 5 12 3 11 1 14-3 16-5 12-7 12-11 12-9 8-6 3-7-1-11-9-9-9-9-14-5-12-2-7-1-8v-9l3-16 9-19 8-11 7-8 8-6zm2 13-11 8-9 9-7 12-4 13v21l5 14 7 11 12 12 6 3 6-1 9-7 11-14 6-13 2-6 1-14-2-13-8-16-8-10-10-8z"
            fill="#DFCF40"
          />
          <path
            transform="translate(676,449)"
            d="m0 0h8l1 4-4 28-6 27-8 26-10 29-12 29-9 20-10 18-10 14-9 11-12 12-8 4-8-1 2-4 10-9 11-14 10-16 13-25 12-28 11-28 11-34 10-41 5-21z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(456,763)"
            d="m0 0 5 5 7 13-2 20v29l3 16 6 16 8 15 12 17 9 10 7 8 7 6 1 2 1 17-5-2-12-8-17-16-10-12-10-16-9-19-7-21-3-14-1-23 2-19 5-18z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(816,1604)"
            d="m0 0h10l14 2 8 3 4 5v3l-19-4h-21l-10 2-10 5-7 6-7 10-4 10-4-2-8-7-16-8-13-4-5-1h-20l-16 4-10 6-10 9-8 11-3 5-5-4-7-8-8-7-17-9-16-4h-12l-14 3-12 6-12 9-8 8-1 2-4-2-7-12-9-11-10-7-8-3-9-1h-11l-14 1v-2l10-5 8-2h10l12 3 16 8 11 9 6 7 4 1 14-9 12-6 19-5 17 1 12 3 16 8 11 7 6 5 4-2 10-9 15-9 12-5 10-2h18l15 4 21 10 5 2 11-13 13-9 9-4z"
            fill="#DFCF40"
          />
          <path
            transform="translate(662,451)"
            d="m0 0h5l-1 10-8 39-7 25-12 34-12 29-13 28-11 19-12 17-11 11-11 7-8 3h-9l-3-1 1-3 11-7 10-8 11-11 12-18 15-29 9-19 13-33 8-24 9-34 6-32 2-2z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1113,423)"
            d="m0 0h1v325l-2-1v-34l-5-1-14-8v-2l-4-2-11-4-8-6-18-10-16-8-29-14-23-10v13h-1l-2-17-5-14-10-20-3-4v-3l6-1v-18l-3-16-3-7-3-2v5h-2v-8l1-5 1-2h2v2h3l6 15 3 16 1 32 2 4 3 1 2-12v-17l-2-15-4-15-5-13-5-8v-5l3-1 5 8 6 14 5 17 3 21v12l-4 20v11l5 8 9 5 30 14 23 11 22 12 17 9 11 7 8 4v-251l1-4h2z"
            fill="#13226B"
          />
          <path
            transform="translate(867,1361)"
            d="m0 0 5 1-3 5-12 14-12 17-11 17-10 18-9 20-9 25-12 38-8 29-5 25-1 10-1 2-11 1 3-29 6-28 8-27 11-32 11-27 11-23 11-18 10-14 8-10 9-9 7-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(253,776)"
            d="m0 0 8 4 21 14 12 9 14 11 15 13 12 11 14 14v2h2l9 11 10 11 11 15 9 13 13 21 14 27 9 21 9 27 6 24 4 22 2 15 1 13v14l-6-2-2-2-4-36-4-23-9-33-7-20-10-23-8-16-9-16-17-25-11-14-18-21-20-20-8-7-13-11-17-13-14-10-15-10-4-2v-2l-3-1 2-4z"
            fill="#DECC3F"
          />
          <path
            transform="translate(890,1359)"
            d="m0 0h10l1 5-15 9-12 11-11 14-10 16-14 27-12 30-12 36-10 36-8 36-5 1h-7l2-15 8-36 9-31 10-29 11-26 10-21 11-19 12-17 11-12 8-8 10-6z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(238,848)"
            d="m0 0 4 1 11 7 14 11 14 12 15 15 7 8 12 15 11 16 11 17 1 4h2l8 16 10 21 10 28 7 28 1 7-4 1-8-4-4-8-9-33-10-25-10-21-14-24-14-18-11-14-14-15-12-12-11-9-14-11-3-3z"
            fill="#DFCE40"
          />
          <path
            transform="translate(877,685)"
            d="m0 0 7 1 3 1 2 4v6l-2-2-2-3-6 9-12 19-14 27-12 25-12 29-11 30-9 28-10 40-5 24v2h19l3-1 7-30 11-35 10-26 11-25 15-30 13-21 13-19 7-9 2-4 4 2v3h-2l-2 5-14 21-13 22-15 29-12 27-13 35-8 25-8 30-3 5-30-1v-9l5-28 8-31 12-36 15-40 19-44-8 2 4-4 10-6 4-6 3-7 8-15z"
            fill="#020104"
          />
          <path
            transform="translate(839,1367)"
            d="m0 0h5l1 2-3 6-11 13-13 21-11 21-13 31-14 41-10 37-6 31-2 14-7 2h-5l1-14 4-25 8-34 12-36 11-30 11-25 10-19 8-12 8-11 6-7z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1106,755)"
            d="m0 0h2v21l-27 27-9 11-12 15-12 17-13 22-15 30-4 9-6-1-9-3 1-6 14-29 12-21 10-15 11-15 10-13 13-15 11-12 9-9 8-7z"
            fill="#DFCF40"
          />
          <path
            transform="translate(608,667)"
            d="m0 0m-5 1h5v2l-5 2 4 10 16 34 13 32 12 36 9 34 8 43 4 31 2 22v15h-39l-2-5-5-32-6-28-8-29-10-30-12-29-9-20-10-19-14-25-16-24-8-10-5-6 7-3h5l2 2 8 2 1 2-8-1-4-1 5 10 13 20 14 24 9 16 9 19 15 36 8 21 9 30 8 31 4 20 4 24h31l-1-13-5-40-5-28-7-30-8-29-10-30-10-26-11-26-10-21-3-5v-2h-8l2-2z"
            fill="#020103"
          />
          <path
            transform="translate(696,447)"
            d="m0 0h5l1 1-1 12-7 36-11 42-11 33-10 24-9 19-11 19-13 18-5 6-11 7-3 2h-4l2-5 11-14 14-22 12-22 11-25 10-27 7-21 8-32 5-26 3-23z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(721,881)"
            d="m0 0h7l11 4 7 8 4 11v17l-1 11v15l5 6-1 5h-7l-8-4-3-4-2-9-1-32-3-6-7 1-3 3-1 33-4 10-7 6-6 2-6-1 1-5 4-4 1-5-1-16-1-9v-12l4-13 7-8 6-3z"
            fill="#DFCF40"
          />
          <path
            transform="translate(714,444)"
            d="m0 0 5 1-2 22-5 27-9 36-12 37-11 30-11 21-10 15-8 10-5 6-6 4-5-1 6-10 10-15 9-16 9-21 11-29 12-40 8-34 7-42z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(695,1075)"
            d="m0 0 10 1 6 4 3 6 2 18 1 24 4 4h5l3-4 1-5v-30l5-10 7-6h9l2 1-2 5-4 5-2 7 2 22v13l-2 8-5 9-9 6-3 1h-8l-10-4-5-4-4-8-2-11v-37l-5-13z"
            fill="#DFCF40"
          />
          <path
            transform="translate(814,1379)"
            d="m0 0h4l-2 5-7 10-12 20-11 21-12 29-11 33-7 25-6 28-5 36-7 2h-5l1-17 5-32 6-25 9-30 9-25 14-32 12-23 7-10 11-11z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(338,1324)"
            d="m0 0 1 2 5 1 2 2h-2v281l-5 5-12 11-11 9-12 11-5 4-4-1-14-13-8-7-9-10-2-5 4 1 11 10 11 9 9 8 4-2 14-13 11-9 9-8 1-2 1-161z"
            fill="#051383"
          />
          <path
            transform="translate(726,443)"
            d="m0 0h12l-1 13-7 38-10 40-12 39-8 20-7 13-13 17-9 8h-4l1-5 11-19 7-15 10-26 10-31 8-32 7-38 3-21z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(862,1359)"
            d="m0 0h22l1 3-9 6-14 14-13 18-10 17-11 21-13 31-12 35-10 37-3 14h-4l-1-1v-9l8-29 17-53 9-21 8-16 9-16 15-22 11-14 8-9 1-3-8 1-9 6-9 9-11 15-12 19-10 19-12 28-13 37-7 23-6 25-3 17-2 1-1-2-2 6h-1v-8l7-31 9-31 12-35 11-26 11-23 13-21 8-10 7-9 1-4-5-1 4-2h3l1 3 9-7z"
            fill="#061382"
          />
          <path
            transform="translate(784,1398)"
            d="m0 0h2l-1 6-9 15-11 23-10 26-11 33-9 36-6 36-2 16-12 1v-11l5-28 9-40 10-36 9-26 11-24 7-11 14-14z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(933,1096)"
            d="m0 0 4 2 10 8 10 9 14 14 10 14 8 14 6 13 6 20 3 20v23l-3 17-4 14h-3l-5-8-1-2v-10l2-19v-9l-3-24-5-17-7-16-8-13-10-13-12-13-9-8-3-11z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(438,1125)"
            d="m0 0 10 3 1 4-12 25-10 19-11 19-16 23-13 16-9 10-32 32h-2v-16l12-11 14-15 11-14 12-16 10-16 12-20 10-18 8-16z"
            fill="#DFD040"
          />
          <path
            transform="translate(1402,90)"
            d="m0 0h3v1449h-1l-1-90v-1342z"
            fill="#080C26"
          />
          <path
            transform="translate(287,932)"
            d="m0 0h13l12 6 6 9 2 8-1 9-5 8-7 6-8 3h-10l-11-4-5-4-4-6-2-6v-10l5-10 8-6z"
            fill="#DFCF40"
          />
          <path
            transform="translate(663,674)"
            d="m0 0h7l10 4 8 7 7 11 7 14v2l8-2 9 1 6 4 1 2-4 4-10 4-2 2-2 8 1 23-2 1-6-5-6-10-5-12-3-17-4-8-5-6-8-4h-7l-12 6-4-7v-8l5-8 7-5z"
            fill="#DFD040"
          />
          <path
            transform="translate(740,1273)"
            d="m0 0 5 3 8 16 7 23 6 11 7 6 4 2h10l8-5 3 1v10l-4 9-7 6-2 1h-13l-8-4-9-8-6-10-3-9v-4l-5 2h-10l-6-3-4-7 13-7 4-5 2-5z"
            fill="#DFD040"
          />
          <path
            transform="translate(946,1379)"
            d="m0 0h13l4 13 1 10-3 12-6 9-9 6-5 2h-14l-9-5-9-9-1-2-4 2-8 11-9 15-11 21-12 28-13 36-7 25-3 11h-3l-2 3v-7l9-34 12-36 9-22 8-18 11-19 12-17 14-20 8-5 3-1h11l6 4 4 5 1 7-2 4-5-1v-7l-1-4-6-2-9 1-5 3-3 6v7l4 8 6 4 4 1h12l10-5 5-6 3-8v-11l-5-10-6-4z"
            fill="#061382"
          />
          <path
            transform="translate(1147,1055)"
            d="m0 0h14l8 3 6 5 5 10v12l-5 8-7 6-9 3h-10l-10-4-8-9-2-5v-11l5-10 6-5z"
            fill="#DFCF40"
          />
          <path
            transform="translate(1016,681)"
            d="m0 0h4v33l-5 8-7 3-4 1-8-3-4-5-6 15h-4l-13-8 1-3 9-6 5-4 1-2h-8l-5-5-1-7 4-6 8-5 10-3z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(867,1105)"
            d="m0 0 5 1 12 8 10 9 4 8v8l-3 5-6 2h-7l8 17v3l-10 2h-8l1-20-4 2h-10l-5-3-3-6v-8l5-12z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(964,739)"
            d="m0 0h4l4 19v16l-6 9-6 3-7-1-8-5-1 5-4 12-4-1-11-7 5-5 7-6 2-4h-7l-6-5-1-2v-7l4-6 8-5 17-7z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(863,1028)"
            d="m0 0 4 1 4 5 7 6 7 10 3 8v8l-4 5h-9l-6-3 8 19v3l-20 3 2-11 3-14-9 5-8-1-4-5-1-8 4-10 12-14z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(889,879)"
            d="m0 0 4 1 10 23 1 11-3 7-5 4-5 1-5-2-4-2 1 20-12-1-7-2 7-11 4-8-7 1-8-2-3-3-1-7 4-9 8-8 16-10z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(944,1304)"
            d="m0 0 9 2 18 5 13 7 3 5-1 9-5 5-6 1 9 8 6 4-3 3-13 5h-3l-4-16-5 4-4 2h-8l-6-3-3-4-2-8v-8l4-20z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(463,1300)"
            d="m0 0 4 1 11 7-2 4-10 8 3 1 6 5 1 2v7l-3 5-5 4-13 5-18 3h-6l-1-5v-23l2-9 5-6 2-1h8l6 3 4 5v2l2-1z"
            fill="#FCFCFC"
          />
          <path
            transform="translate(869,957)"
            d="m0 0 4 1 9 13 6 12 1 3v11l-5 6h-8l-6-3 2 19-16-1 1-4 5-13-5 1h-7l-6-5-2-5 2-9 7-11 11-10z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(886,1180)"
            d="m0 0 5 2 14 8 10 9 4 6v7l-5 5-4 2h-5l10 13v4l-13 5h-3l-3-19-7 4-8 1-6-5-2-5v-11l4-12 8-13z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(922,806)"
            d="m0 0h2l3 18 3 10v12l-4 6-5 2-8-1-5-4-1 2-1 14-1 4-17-4-1-4 9-9 3-5-12-3-3-5 1-7 4-6 7-6z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(567,1088)"
            d="m0 0 11 1 9 2-2 5-7 11-2 3 6-1 6 3 3 4v9l-4 8-9 8-11 7-6 3h-3l-11-23-1-4v-9l3-5 5-3h7l8 4-1-2z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(910,1243)"
            d="m0 0 9 3 11 5 14 9 4 6v7l-3 5-4 2h-6l9 11 3 3v2l-14 5h-3l-4-16h-2l-4 3h-9l-6-4-3-8v-8l3-13z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(472,893)"
            d="m0 0 4 4 7 9 9 10 12 11 8 5v3l-5-1-6-1-10 9-10 13-4 4-3-4h-2l-2 3-6 2h-7l1-3h4v-2l12-5 10-7 9-8 4-5-1-4-9 5-10 7-11 4h-8l-8-7-2-4v-7l3-6 8-8 11-8v-3l-3-2h5z"
            fill="#13226C"
          />
          <path
            transform="translate(572,861)"
            d="m0 0h4v22l5-4h7l5 3 3 5v8l-4 11-8 14-3 5-4-2-14-11-8-8-3-6v-10l5-5h10l-8-16v-3z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(543,790)"
            d="m0 0h2l4 19 6-5 2-1h7l7 6 1 3v14l-5 17-4 8-16-8-12-9-4-6-1-3v-9l3-3 7-1h2l-8-10-5-7 7-3z"
            fill="#FCFCFC"
          />
          <path
            transform="translate(544,1165)"
            d="m0 0 11 3 7 2-2 4-10 11-1 2 8-1 6 3 2 3v6l-6 9-10 7-15 7-6 2-3-8-4-15v-13l3-7 7-3 5 2 3 4 3 1 1-15z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(582,939)"
            d="m0 0h5v10l-2 10 9-4 7 1 4 3 1 7-5 12-8 13-6 8-5-2-11-12-9-11-2-3v-9l4-5 6-1 8 4-7-18v-2z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(509,1235)"
            d="m0 0 17 8-4 5-8 7-4 3 10 5 2 2v6l-4 6-5 5-14 6-13 5h-3l-2-9-1-8v-14l3-8 4-4h8l5 3 3 3 4-17z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(993,1073)"
            d="m0 0h13l7 4 7 8 1 2v14l-5 10-9 10-14 9-8 4-4-1 1-4 11-9 7-8 2-4v-6l-5-8-6-3h-7l-10 3-14 10-5 1 1-4 9-11 11-9 12-7z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(514,728)"
            d="m0 0h2l3 13v3l9-7h7l5 6 2 9-1 11-4 19-4 1-21-10-11-8-3-5 1-6 5-5h8l-6-7-6-6v-2z"
            fill="#FCFCFC"
          />
          <path
            transform="translate(577,1012)"
            d="m0 0 15 1-2 10-3 10 8-3h7l4 4v7l-6 12-12 12-7 6-4-2-8-11-8-16-1-6 3-5 4-3h7l6 4-2-7z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1024,1119)"
            d="m0 0h10l9 3 6 5 4 7 1 9-3 8-5 7-13 8-19 7-6 2-5-1 2-4 16-8 5-2 2-4 3-7-1-6-4-6-6-3h-9l-12 4-5 2h-6v-4l14-9 13-6z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1012,1223)"
            d="m0 0h16l20 3 10 4 9 8 3 6v11l-3 7-5 6-8 4-5 1h-13l-14-3-15-5-3-2v-2h8l13 2h7l8-3 5-4 1-3v-10l-4-7-11-4-21-4v-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(107,50)"
            d="m0 0h60l240 2v1l-313 1-10 2-12 6-9 8-8 13-3 8-1 6-1 342-1 29h-1v-375l3-10 7-12 5-6 11-8 12-5 5-1z"
            fill="#080C26"
          />
          <path
            transform="translate(476,671)"
            d="m0 0h2l5 16 7-6 9-1 6 5 3 7v10l-5 22-4-1-22-9-9-7-3-6 1-5 4-3h7l-5-5-10-8v-2z"
            fill="#FCFCFC"
          />
          <path
            transform="translate(419,811)"
            d="m0 0h14l7 1 2 2v3l-2 1-18 1-10 3-7 5-2 3v8l3 5 7 4 11 2h22v4l-9 3-14 2h-24l-9-3-6-6-3-12 1-8 5-8 7-5 13-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1083,977)"
            d="m0 0 5 1 2 4 5 25 7 23 8 21 9 19 13 23 10 14v2h2l6 9 6 7 7 8 9 10 14 13 4 2 5 5 13 10 6 4 2 4-1 4-8-4-12-9-13-11-13-12v-2l-3-1-7-8-8-9-4-5-7-9v-2h-2l-7-11-7-10-5-9-9-17-9-20-9-25-7-27-2-10z"
            fill="#DDC33D"
          />
          <path
            transform="translate(1035,1172)"
            d="m0 0h16l11 4 6 7 2 5v12l-4 6-8 6-13 5-13 2h-21v-4l2-1 15-1 10-3 6-5 2-5v-9l-3-5-9-4h-13l-5 1h-8l-1-4 6-3z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(406,760)"
            d="m0 0h14l25 5 3 2-1 4h-8l-12-2h-9l-9 4-4 4-1 9 4 8 10 5 19 3 5 2-1 3-3 1h-19l-16-3-12-6-7-7-2-10 2-9 6-7 8-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(932,1368)"
            d="m0 0 6 4 6 3 2 4-10-3h-10l-12 4-11 8-8 8-11 14-11 17-13 24-11 25-13 38-8 31-6 28-4 1v-11l6-28 8-29 11-32 13-29 12-23 12-18 8-10 11-11 12-8 13-4 8-1z"
            fill="#061482"
          />
          <path
            transform="translate(795,456)"
            d="m0 0h18l20 4 9 2h15l9-2-1 8v17l-3 1-3-9v-3h-25l-19-3-11-1h-21l-16 3-14 5h-5l6-7 14-8 10-4z"
            fill="#13226C"
          />
          <path
            transform="translate(439,857)"
            d="m0 0h9l1 4-7 3-11 4-9 6-4 6v8l4 6 5 3 5 1h11l10-3 10-5 3 1-1 3-10 7-15 8-6 2h-18l-10-4-7-8-1-3v-8l3-8 7-8 14-9 12-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(588,1543)"
            d="m0 0 2 1 1 4v8h24l26 4h25l17-3 13-5 4-2h3v5l-9 7-13 6-17 5h-20l-48-6-11 1 1-16z"
            fill="#13226C"
          />
          <path
            transform="translate(614,462)"
            d="m0 0h1v8l-7 28-12 38-9 25-15 31-14 23-11 14-8 8-7 4h-11l-8-5-3-5 1-9 5-5 5 1-2 4-3 3 1 7 6 2h8l5-5 3-7h4l-1-5 4 3 2-4 14-21 10-17 8-17 10-26 10-30 8-32 3-4v-5z"
            fill="#12216E"
          />
          <path
            transform="translate(900,1359)"
            d="m0 0h2v2h11 4l9 1 1 2-17 1-11 4-9 6-13 13-11 15-12 21-8 16-10 23-11 30-9 28-9 34-4 20-3 1-1-3v-8l8-33 8-28 12-36 12-29 10-20 9-15 10-14 14-15 15-10 4-1z"
            fill="#061481"
          />
          <path
            transform="translate(649,454)"
            d="m0 0 4 1-3 13 1 1-1 11-6 26-10 33-13 33-9 20-13 26-9 15-9 12-13 13-10 7-7 3-7 1-1-3 14-8 10-8 7-7 12-16 11-18 11-21 11-28 13-36 8-27 5-22z"
            fill="#061481"
          />
          <path
            transform="translate(501,932)"
            d="m0 0 5 1-2 5-10 11-2 4v12l5 8 5 3h12l7-4h4v9l-5 5-9 6-6 2h-12l-8-3-6-5-4-9v-11l4-9 8-11 9-10z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(937,657)"
            d="m0 0 5 1 7 19 3 16v10l-2 10-6 9-9 6-5 2h-14l-11-6-7-10-6-15-2-7 1-5 3-2h4l8 23 4 6 6 4 3 1h9l7-3 5-5 2-5 1-10-4-20-4-13 1-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(519,1303)"
            d="m0 0h16l9 4 6 7 8 19 3 9-1 4-6 1-4-9-5-13-7-9-5-2h-10l-8 3-5 5-2 7v8l4 16 5 14v7l-2 2-4-1-8-19-4-16v-17l3-8 4-5 10-6z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(946,1038)"
            d="m0 0h13l10 5 5 6 1 3v15l-4 10-6 9-9 10-4 4h-4l1-6 9-13 2-6-1-10-3-5-9-4-12 1-5 1-2-1v-8l4-5 8-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(397,721)"
            d="m0 0 1 3-8 20-8 32-2 11v15l-1 3v13l2 30 4 16 2 6 4 13 6 13 9 16 3 4v2l3 1 10 14 4-4 6-11h2l-1-2-4-2 3-2h8l-3 7-5 8-1 3v12l3 6 9 6 7 4v2l-3 3 5 5 8 7 14 10 10 7 12 7 12 4 14 6 4 2 4 4-2 29-2 4-1-5 1-11v-13l-27-14-22-14-17-13-15-13-17-17-13-17-8-11-8-14-8-16-6-15-5-19-4-25-1-14 1-19 4-27 6-22 7-19z"
            fill="#030309"
          />
          <path
            transform="translate(1057,1150)"
            d="m0 0 3 3 10 25 3 17 1 10v33l-4 26-2 3-1-6 2-6v-11l-5-8-8-6-8-3-20-3v-2l-11-1v-1l14-1 1-1 17-3 14-7 5-6 1-2v-12l-2-7 1-3h-2v-4h-4v-2h-2v-2l-7-1-10-2 2-4 8-7z"
            fill="#14236C"
          />
          <path
            transform="translate(705,446)"
            d="m0 0h1v12l-6 33-7 30-9 30-7 21-11 28-9 19-12 19-7 10-2 5-14 7-2-1 5-4 14-19 9-15 11-21 10-24 10-28 10-36 7-30 6-35z"
            fill="#061382"
          />
          <path
            transform="translate(722,988)"
            d="m0 0 7 1 6 9 3 10v12l-4 11-6 8-5 4-5-3-7-12-2-7v-14l4-9 6-8z"
            fill="#DFCF40"
          />
          <path
            transform="translate(887,610)"
            d="m0 0 9 2 8 3 8-1 2 7 2 8h-3l-11-3-11 1-9 2h-11l-16-2h-11l-13 4-5 1 5-17h18l8-3 11-1 7 3 7-1z"
            fill="#13226C"
          />
          <path
            transform="translate(685,449)"
            d="m0 0 3 3v12l-4 25-7 30-8 27-12 32-9 20-8 16-9 16-14 21-11 14-2-1-1-3v3 3l-5 1 2-7 9-9 12-16 8-13 10-19 15-36 9-25 10-31 6-26 4-24z"
            fill="#061482"
          />
          <path
            transform="translate(875,1361)"
            d="m0 0h4v5l-8 7-9 9-13 18-10 17-11 21-13 31-12 35-10 37-3 14h-4l-1-1v-9l8-29 17-53 9-21 8-16 9-16 15-22 11-14 9-8z"
            fill="#061383"
          />
          <path
            transform="translate(631,457)"
            d="m0 0h4l-2 12-9 38-9 29-11 29-9 20-11 22-13 21-9 12-7 8-11 7-8 3-4 1h-10v-2l-4-2 15-2 12-6 10-9 13-17 13-21 8-15 13-30 10-26 8-26 9-37z"
            fill="#051383"
          />
          <path
            transform="translate(254,1142)"
            d="m0 0 3 3h1l1 248v145h-1l-2-149h-1l-1-43v-38l1-5-1-8z"
            fill="#020F89"
          />
          <path
            transform="translate(619,1402)"
            d="m0 0 3 1-4 12-2 2-9-1-13 4-3 1h-8l-11-3-10 3-7-1-5-2h-11l-3-9-1-6 8 2h16l11-2 30 2z"
            fill="#13226C"
          />
          <path
            transform="translate(928,1022)"
            d="m0 0 8 2 4 2 9 2 14 7 10 7 10 8 5 5 10 8 10 7 3 2 1 4-6-2h-13l-9 3-13 9-5 4-3 1-4 4v-3l9-11 5-10 1-4v-15l-4-7-6-4-5-2-11-1 1-2 5 1v-3h-2v2h-8l-13 5h-3l-1-2v-14z"
            fill="#101F71"
          />
          <path
            transform="translate(631,1415)"
            d="m0 0h16l8 4 5 6 2 5v10l-5 8-10 5-9-1-5-3 1-4 4 1h9l5-3 2-2 1-7-3-6-4-3-4-1h-8l-9 4-14 9-9 4-4 1h-8l-8-3-2-4 1-5 22-5 21-9z"
            fill="#13226C"
          />
          <path
            transform="translate(760,1383)"
            d="m0 0 7 1 5 4 5 7 4 1v3h-2l-1 4-11 11-7 11-8 17-9 24-8 26-9 36-4 1 1-10 5-21 1-10 11-33 11-26 8-14 11-13v-7l-5-5h-7l-8 6-8 16-13 25-2 2-3-1 11-23 11-22 8-8z"
            fill="#061482"
          />
          <path
            transform="translate(805,578)"
            d="m0 0h7l7 5 1 3h-12l-7 2-4 4v9l6 5 8 1 11-4 18-10 10-4 9-1 7 3 2 4v5l-2 2-20 4-14 5-12 3-9 1-9-1-8-5-4-5-1-2v-10l5-8 5-4z"
            fill="#13226C"
          />
          <path
            transform="translate(968,533)"
            d="m0 0 4 4 7 15 6 20 3 21v12l-4 20v11l5 8 9 5 6 3v3l-6-1-14-6v13h-1l-2-17-5-14-10-20-3-4v-3l6-1v-18l-3-16-3-7-3-2v5h-2v-8l1-5 1-2h2v2h3l6 15 3 16 1 32 2 4 3 1 2-12v-17l-2-15-4-15-5-13-5-8v-5z"
            fill="#061482"
          />
          <path
            transform="translate(1154,449)"
            d="m0 0h2l1 14 1 27v48l-3 28-5 38-1 10v38l-1 1 2 3 1 9-5-1-4-16-1-7v-27l3-22 6-34 2-17 1-19z"
            fill="#13226C"
          />
          <path
            transform="translate(1e3 1268)"
            d="m0 0h7l24 9 12 7 7 8 2 5v9l-5 9-7 4-2 1-9-1-4-3-1-6 5-11v-6l-4-6-8-6-16-7-2-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1404,1808)"
            d="m0 0h1l1 35v97l-3 12-5 10-9 10-9 7-12 5-4 1-13 1h-192v-2h-9v-1l210-1 12-3 11-6 8-7 8-13 3-11 1-15z"
            fill="#0F1B54"
          />
          <path
            transform="translate(723,965)"
            d="m0 0 6 1 13 11 7 10 6 13 2 13-1 14-5 13-6 10-9 11-8 6-6 1-8-5-10-10-7-11-5-14v-21l4-13 7-12 10-10zm-1 7-6 4-5 4-10 13-5 11-1 5v11l4 16 7 13 8 10 5 4h8l12-12 9-14 4-10 1-6v-10l-3-13-8-14-6-7-8-5z"
            fill="#020103"
          />
          <path
            transform="translate(741,448)"
            d="m0 0h1v9l-7 36-12 48-11 36-2 5h2l1-3 3-1-1 7-11 27-9 20-3 1 2-9 8-21-2-1 1-3h-2l-1-4 8-19 11-35 11-42 7-37 2-7 3-5z"
            fill="#071580"
          />
          <path
            transform="translate(281,1030)"
            d="m0 0 4 1 2 2v9l1 7-16 7-16 6-11 1-5-3-1-5 3-7 8-7 12-6 13-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(723,444)"
            d="m0 0h1l-1 14-5 30-6 27-7 27-12 35-10 24-8 15-7 12h-3l1 3-4 3-2-4 12-19 9-19 15-43 9-30 8-34 4-26 2-14z"
            fill="#061482"
          />
          <path
            transform="translate(1191,941)"
            d="m0 0 5 1 5 4 2 5v7l-4 6-8 7-9 4-10 2-8-8-15-3 2-4 16-6 11-4 10-9z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(274,1059)"
            d="m0 0h5l7 8 2 1h9l5-1v4l-6 4-18 4-9 4-7 8-3 3-11-4-4-5-1-5 3-7 13-8 12-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(415,710)"
            d="m0 0 9 2 3 4-2 5-3 5-1 7 3 9 5 6 10 6 10 4 1 4-11-1-16-6-11-7-7-6-4-7-1-11 4-8 8-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(892,1425)"
            d="m0 0 3 2-1 4-12 21-10 21-11 27-11 31-7 26-2 7h-3l-2 3v-7l9-34 12-36 9-22 8-18 11-19 5-5z"
            fill="#061382"
          />
          <path
            transform="translate(472,954)"
            d="m0 0 4 2 1 2 2-1-3 9v11l4 9 6 5 7 2 12 1v1l-7 2 2 2h7l16-10h3v21l-6-1-14-6-12-4-18-11-10-8-12-9-8-7 2-4h2l-3-4h15l-1 3 9-2z"
            fill="#13226D"
          />
          <path
            transform="translate(789,1396)"
            d="m0 0 3 2-1 5-12 22-13 29-10 27-9 29-6 24-4 22-4 3-1 5h-1v-10l5-25 7-28 12-36 11-27 11-23 9-14h2z"
            fill="#061383"
          />
          <path
            transform="translate(1046,777)"
            d="m0 0h13l11 1 4 2-2 5-9 10-7 9-3 2h-28l1-4 8-11 9-12z"
            fill="#DFCE40"
          />
          <path
            transform="translate(1076,746)"
            d="m0 0h15l13 2 1 3-7 8-12 11-5 3h-20l-8-2 2-6 13-13z"
            fill="#DFD040"
          />
          <path
            transform="translate(516,1419)"
            d="m0 0h10l12 3 14 5 11 1 3 1v9l-4 4-8 1-9-3-7-5-9-4-4-1h-7l-6 3-2 5 3 7 10 5-1 2h-8l-6-3-4-5-1-3v-9l3-6 8-6z"
            fill="#13226C"
          />
          <path
            transform="translate(903,538)"
            d="m0 0 2 1 4 17v12l-4 6-18 11-3 1-2 4-2 3h-2l1-6 5-7v-2l-3-1-20 5h-7l-9-3-5-5-3-6 1-9 4-6 6-4h5l-9 9-1 3v7l3 6 2 1h7l19-9 3-1h7l3 5v6l7-3 9-8v-10l-2-8v-7h2z"
            fill="#13226D"
          />
          <path
            transform="translate(304,1430)"
            d="m0 0h2l3 9-1 9-7 35-2 14v75l-3 7h-2l-2-63v-13l2-24 5-26 4-21z"
            fill="#13226C"
          />
          <path
            transform="translate(451,1196)"
            d="m0 0 2 1 4 26v7l-10 14-10 12h-2l-1-2-1-13v-17l8-14 8-12z"
            fill="#DFCF40"
          />
          <path
            transform="translate(427,1232)"
            d="m0 0 2 1 1 14v17l-4 6-9 10-8 8-4 1v-29l4-6 12-15z"
            fill="#DFD040"
          />
          <path
            transform="translate(471,1159)"
            d="m0 0 3 2 6 22v10l-6 11-9 14-4-1-3-13-1-6v-13l12-24z"
            fill="#DFCF40"
          />
          <path
            transform="translate(398,1268)"
            d="m0 0 2 1v15l-1 15-7 7-8 7-10 8h-2v-24l3-7 21-21z"
            fill="#DFCF40"
          />
          <path
            transform="translate(1e3 844)"
            d="m0 0h20l-1 6-9 15-5 6-11 4-12 3h-4l1-7 11-22 6-4z"
            fill="#DFD040"
          />
          <path
            transform="translate(693,1613)"
            d="m0 0 5 1-3 3-20 11-13 10-4-1-15-10-16-8-3-1v-3h34l27-1z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(1021,811)"
            d="m0 0h26l-1 5-8 11-6 9-5 3h-24l-1-2 10-18 5-6z"
            fill="#DFCF40"
          />
          <path
            transform="translate(958,599)"
            d="m0 0 5 5 8 14 9 19 3 12v13l-2 9-5 8-7 6-5 2h-8l-1-1v-5l13-7 4-6 2-13-2-12-7-17-6-10-1-3z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(929,579)"
            d="m0 0 9 1 5 3 4 8v9l-3 6-5 4-5 2-12-1-28-7-6-3-3-3 1-7 4-2h7l20 9 10 3h7l7-4v-7l-5-5-7-4z"
            fill="#13226C"
          />
          <path
            transform="translate(488,1346)"
            d="m0 0h8l1 5-14 7-4 5-2 7v9l3 13 7 16 7 14v9h-3l-7-10-11-23-5-16-1-14 2-8 4-6 6-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(407,1225)"
            d="m0 0h15l1 3-6 9-9 11-5 5-3 2h-24l2-5 11-13 8-10 1-1z"
            fill="#DFCF40"
          />
          <path
            transform="translate(1150,382)"
            d="m0 0 4 1 15 14 10 9 14 12 2 2-1 3-3 1-6-7-6-3-10-9-11-9-6-5-13 11-11 9-14 12-1 37h-1v-9h-2l-1 4v-37l11-9 16-15 8-7z"
            fill="#061382"
          />
          <path
            transform="translate(338,1324)"
            d="m0 0 1 2 5 1 2 2h-2v281h-1l-1-169-1-16-2-1-1-10z"
            fill="#13226C"
          />
          <path
            transform="translate(1198,972)"
            d="m0 0 6 1 3 4v6l-6 9-14 7-13 4h-7l-1-16 19-10z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(933,660)"
            d="m0 0 3 3 6 21 2 16-2 9-5 7-5 3-4 1h-9l-6-3-5-5-4-6-6-19v-2l-7 3 1 7 6 17 7 11 11 6 12 1v1l-12 2-7-3v-3l-6-2-6-8-9-19v-7l-1-4-9-2 2-3 19-5h3l1 6 3 14 4 10 6 7 9 1 8-3 4-5 1-3v-12l-4-17-4-10 2-4z"
            fill="#061481"
          />
          <path
            transform="translate(392,1728)"
            d="m0 0v3l-7 10-6 9-3 6-1-2h-2v4l3-1 2 1-1 3h-88l1-3-4 1-7-1v-3l5-1 52-1h13l23-1 14-20 1-2 4-1z"
            fill="#020F89"
          />
          <path
            transform="translate(957,613)"
            d="m0 0h2l6 11 7 16 2 7 1 11-2 10-4 6-8 5-5 2v5l6 1v1h-9v14h-1l-3-21-7-21-1-4h-3l2-4 2-5 2 3 5 12 5-1 3-5-1-10-6-12-1-8h2l1 3 3 3 6 14 1 3v11l-4 6-5 6v3l9-2 5-5 2-5v-14l-5-15-6-11-3-5z"
            fill="#061481"
          />
          <path
            transform="translate(522,1609)"
            d="m0 0 46 4 20 1 3 1-1 3-25 10-11 6-4-1-8-8-15-10-5-3z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(523,1317)"
            d="m0 0h11l7 6 5 11 4 12-1 4-5 2-3-4-6-15-2-3-6-1-5 3-1 1v9l5 15v6l-3 4h-2l-6-16-3-12v-13l5-6z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(369,1260)"
            d="m0 0h23l3 1-2 5-9 10-9 8-7 2h-16l-6-1 3-5 9-10 8-8z"
            fill="#DFCF40"
          />
          <path
            transform="translate(433,1191)"
            d="m0 0h12l1 5-9 14-8 9-7 2h-17l-1-2 10-16 7-9 6-2z"
            fill="#DFCF40"
          />
          <path
            transform="translate(797,1600)"
            d="m0 0h6v2l-14 7-13 11-6 7-5-1-14-7-19-7v-2l11-2 44-6z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(738,1182)"
            d="m0 0h8l8 5 4 6 1 7-2 10-5 10-4 5-6 4h-3l1-9 1-4v-14l-2-4-10-5 1-6z"
            fill="#DFCE40"
          />
          <path
            transform="translate(985,819)"
            d="m0 0h4l4 11 1 10-8 16-8 14h-4l-5-14v-8l8-16z"
            fill="#DFCF40"
          />
          <path
            transform="translate(692,1333)"
            d="m0 0 13 1 8 4 7 8 2 6v13l-5 15-11 21-5 7-3-1 1-5 13-24 5-14v-11l-4-6-8-7-9-2-8 2-8 7-7 9-10 18-2 3-4-1 3-9 10-18 7-9 7-5z"
            fill="#061382"
          />
          <path
            transform="translate(498,1347)"
            d="m0 0h2l1 6h2l5 13v10h-2l-2-3h-6l-3 2v8l5 12-1 5-3-1-6-14-1-5v-7l5-6 6-3-1-5h-7l-8 5-2 4v15l5 15 7 13 2 8h4v5h-3l-1-3-4-2-10-19-5-15-1-6v-9l3-9 7-6 9-4h2z"
            fill="#061482"
          />
          <path
            transform="translate(705,802)"
            d="m0 0 4 1-1 8-1 4v12l3 5 9 6-2 5-4 3-3 1h-10l-8-7-3-7v-9l6-12 7-8z"
            fill="#DFCE40"
          />
          <path
            transform="translate(930,666)"
            d="m0 0 3 3 5 17 1 6v12l-3 6-5 4-6 2-9-1-7-8-5-13-1-10 2-2 5 1 5 16 4 5 2 1h6l3-5-1-15-4-12 1-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(760,803)"
            d="m0 0 5 3 9 8 4 7 1 4v10l-6 8-5 3-10 1-6-3-4-5 2-4 6-3 4-6 1-3v-13z"
            fill="#DFD040"
          />
          <path
            transform="translate(616,1303)"
            d="m0 0h15l8 3 8 7 4 11v8l-4 13-8 16-2 3-4-1 3-9 8-16 2-12-4-10-9-6-4-1h-9l-8 3-7 6-15 30h-4l1-8 8-18 7-10 9-7z"
            fill="#061482"
          />
          <path
            transform="translate(1073,718)"
            d="m0 0 4 1 1 3v9l-2 8-7 8-9 9-9 7-3-1v-10l1-11 11-12 11-10z"
            fill="#DFCD40"
          />
          <path
            transform="translate(927,665)"
            d="m0 0 1 3-2 2 2 9 2 6 1 15-3 5-1 1h-6l-6-5-3-8-3-10-6 1-2-4v-4l13-7 4-3z"
            fill="#061382"
          />
          <path
            transform="translate(752,621)"
            d="m0 0 2 1-1 6-14 27-4 12v13l4 7 12 6 4 1h8l7-4 8-10 8-16 6-9 2 1-1 7-8 16-8 11-5 5-5 3-4 1h-9l-10-3-11-8-4-8v-12l4-13 8-16 9-17z"
            fill="#061482"
          />
          <path
            transform="translate(337,1447)"
            d="m0 0 3 2 1 3 1 29v110h-2v3h-2v13l2 1-4 2z"
            fill="#14236C"
          />
          <path
            transform="translate(460,1156)"
            d="m0 0h6l-1 6-10 19-6 4-14 2h-7l-1-3 10-19 5-4z"
            fill="#DFCE40"
          />
          <path
            transform="translate(473,1413)"
            d="m0 0h3l2 6v30l3 19 6 18 4 10v5l-2 1-5-5-5-9-6-14-4-19v-29l2-9z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(592,1446)"
            d="m0 0 11 1 6 3 5 6 2 6-1 8-6 7-8 4h-5l1-5 9-6 3-5-1-6-6-3-7 1-13 8h-11l-5-2-2-2 1-5 3-2 12-3z"
            fill="#14236C"
          />
          <path
            transform="translate(523,1313)"
            d="m0 0h10l6 3 7 9 6 15 2 6 6-1 2-3 1 3 9 4v1l-17 4-17 8-4 3h-2v-3h-4l-1-3 3-1 1 2 6-5 6-3 5-1 1-5-6-17-5-8-4-3h-11l-7 4-3 4v13l6 21 1 6-3 3-8-22-2-10v-8l3-9 6-5z"
            fill="#071481"
          />
          <path
            transform="translate(1042,748)"
            d="m0 0 2 1v21l-4 7-12 14-5 5-3-1-2-9v-10l4-8 15-16z"
            fill="#DFCE40"
          />
          <path
            transform="translate(783,732)"
            d="m0 0 9 1 5 5 2 4v12l-1 2-7-1-10-3-9 1-9 5-5 2 1-7 6-11 7-6 6-3z"
            fill="#DFCF40"
          />
          <path
            transform="translate(683,1186)"
            d="m0 0h7l8 4 1 2-4 5-7 5-2 6 2 22-5-1-7-7-5-10-1-4v-12l4-6 5-3z"
            fill="#DFCE40"
          />
          <path
            transform="translate(960,533)"
            d="m0 0 3 1 7 10 5 10 5 16 2 10 1 10v17l-2 10-1 2-4-1-2-4-1-32-3-16-6-15-4-9-1-7z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(815,669)"
            d="m0 0 3 1-3 9-7 17-1 3v11l5 10 6 4 3 1h10l10-5 7-8 9-16 6-11h4l-2 9-9 17-8 11-9 7-7 2h-10l-8-3-8-7-4-8-1-9 2-10 6-15 4-8z"
            fill="#061481"
          />
          <path
            transform="translate(685,1527)"
            d="m0 0h5l-2 4-14 9-15 7-12 3-13 1-14-3-5-3-2-5 36-2 14-3z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(269,1010)"
            d="m0 0h8l5 3 2 5v5l-3 2-12 3-11 5h-10l-4-3-1-8 5-6 11-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1018,1082)"
            d="m0 0 5 5 6 7 4 8 5 7v2l3 1 3 4v2h2l5 10-1 2-4-5-7-4-5-1h-10l-12 3-13 7-3-1 5-5 8-6 7-8 4-9v-14z"
            fill="#12206F"
          />
          <path
            transform="translate(1010,784)"
            d="m0 0h4l2 11v12l-10 16-6 7-3-1-4-16v-6l7-11 3-5 5-5z"
            fill="#DFCE40"
          />
          <path
            transform="translate(722,982)"
            d="m0 0 6 1 7 7 5 10 2 7v12l-3 11-6 10-8 8-3 1-6-5-7-11-3-8-1-8v-9l3-10 6-9zm0 6-5 4-6 9-2 6v14l4 11 7 10 3 1 8-7 6-12 1-4v-12l-3-10-4-6-4-4z"
            fill="#020103"
          />
          <path
            transform="translate(725,591)"
            d="m0 0h1v6l-16 33-7 12-6 6h-10l-5-4-5-7h-6l-1-5 5-5 9-10 11-16 2-4h2v2h2l-1 5-12 16-7 10 1 5 3 4v2l10 1 5-4 15-29 8-17z"
            fill="#071481"
          />
          <path
            transform="translate(466,890)"
            d="m0 0h3v2l3 1v4l-6 2-16 9-11 9-3-2h3l-1-2h-6l-2 1 4 2v2h-2l-2 6-6 9h-3l-10-14-3-3-7-11-1-4 8 6 8 3h18l12-5 12-7 5-4h2z"
            fill="#0E1C76"
          />
          <path
            transform="translate(805,480)"
            d="m0 0h12l13 4 6 5v3l-6 1-7-2-13-1-16 3-20 7-13 5-4-1 9-7 21-11 14-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(666,459)"
            d="m0 0 5 1-1 11-11 44-12 36-11 28-2 5h-2l2-9 5-13-1-3 13-37 7-26 7-35z"
            fill="#12216D"
          />
          <path
            transform="translate(686,1273)"
            d="m0 0h2l-1 6-6 9-6 5-8 4h-10l-6-5-3-7 1-6 3-4h5l6 4 6 1 10-3z"
            fill="#DFCF40"
          />
          <path
            transform="translate(761,631)"
            d="m0 0h3l1 3-8 16-7 15v10l3 3h7l5-6 11-22 5-4 1 1-1 8-8 17-6 8-5 4-9 1-6-4-3-5-1-6 4-13 11-23z"
            fill="#061481"
          />
          <path
            transform="translate(691,1349)"
            d="m0 0h11l5 5 2 8-3 10-12 24-4 4-3-2 2-6 12-23 2-5v-5l-4-3h-6l-7 6-6 10-7 14-4-2 2-8 8-16 8-9z"
            fill="#051383"
          />
          <path
            transform="translate(1064,1271)"
            d="m0 0h2l-2 10-6 20-3 5-7 16-6 9-1 5-7-6-6-9 2-3 9 1 8-4 5-9v-12h2l-8-14v-3z"
            fill="#13226C"
          />
          <path
            transform="translate(382,776)"
            d="m0 0h1v9l3 8 8 7 9 4 9 2v1l-5 1h-7v2l-11 6-3 3 4 1-5 5-3 7-1 5-2-2-1-17v-13l1-3v-15l2-10z"
            fill="#14236C"
          />
          <path
            transform="translate(1195 1e3)"
            d="m0 0 4 1 5 5-1 5-5 5-12 6-3 1h-14l-1-2v-9l1-3 24-8z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(685,449)"
            d="m0 0 3 3v12l-4 25-7 30-8 27-10 27h-3l1-5 7-19-1-1-1-2 11-34 6-26 4-24z"
            fill="#071481"
          />
          <path
            transform="translate(932,471)"
            d="m0 0h10l10 3 5 4 1 5-4 1-12-4-5-1h-14l-9 3-11 7-5 3-1-1 1-15 2-4 10 1 8 1z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1293,50)"
            d="m0 0h54l17 1 12 4 10 6 10 10 6 11 2 4v4l-3-1-4-9-6-9-8-8-14-7-9-2-200-1v-1l96-1z"
            fill="#090F30"
          />
          <path
            transform="translate(638,560)"
            d="m0 0 2 2-7 19-1 7-11 24-10 19-11 16-12 14-8 7-6 2v-4l9-7 8-8 14-21 13-24 12-27 7-18z"
            fill="#071481"
          />
          <path
            transform="translate(649,454)"
            d="m0 0 4 1-3 13 1 1-1 11-6 26-10 33-10 26h-3l3-12 3-8v-7l10-30 7-28 4-23z"
            fill="#111F70"
          />
          <path
            transform="translate(527,963)"
            d="m0 0h2l2 33v32l-3 33-4 27h-1v-12l1-1 1-10v-19l2-2 2-29-3-2v-2l-3-1h3v-21l-11 6-8 5h-7l-3-3 3-2h5v-2l10-4 8-6 1-2 2-17z"
            fill="#11206F"
          />
          <path
            transform="translate(399,731)"
            d="m0 0 3 4 6 9 10 7 12 6 10 4 3 1 10 2-4 4-9-3-20-4h-14l-10 3-8 5-3 4-1 3h-2l1-10 3-6 6-1 16-5v-3l-7-7-5-7z"
            fill="#12216E"
          />
          <path
            transform="translate(492,1358)"
            d="m0 0h7l2 6-9 6-2 3v7l4 13 4 9v11l-2 2-6-9-6-13-3-10v-15l4-6z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(754,1424)"
            d="m0 0 3 1-5 10v7l-9 24-8 26-9 36-4 1 1-10 5-21 1-10 11-33 11-26z"
            fill="#071580"
          />
          <path
            transform="translate(527,1328)"
            d="m0 0 6 1 5 8 5 13 2 1 4-1-3 3-6 1-5 3-4 4-2-1-5-5-4-13v-9l4-4z"
            fill="#08157F"
          />
          <path
            transform="translate(397,721)"
            d="m0 0 1 3-8 20-8 32-2 11v15l-1 3v13l2 30 4 16 2 6 4 13 6 13 9 16 3 4v2l3 1 3 7 6 8 5 8-1 2-10-13-8-11-8-14-8-16-6-15-5-19-4-25-1-14 1-19 4-27 6-22 7-19z"
            fill="#020103"
          />
          <path
            transform="translate(743,611)"
            d="m0 0 3 1-3 9-15 29-6 16-1 6v9l3 9 6 8 11 7 7 2 16 1v1l-13 1-12-3-11-8-8-10-4-8-1-18-3-1 7-8 12-23 10-18z"
            fill="#061482"
          />
          <path
            transform="translate(617,1317)"
            d="m0 0h12l5 3 3 5 1 7-4 11-8 15-4-1 7-18 2-7v-6l-3-2h-9l-5 4-9 21-2 2-4-1 2-10 7-14 7-8z"
            fill="#061382"
          />
          <path
            transform="translate(478,1143)"
            d="m0 0 10 3 11 7-3 9-8 15-4 3-3-9-5-20 1-7z"
            fill="#DFCD40"
          />
          <path
            transform="translate(718,547)"
            d="m0 0 2 4-8 26-2 5h2l1-3 3-1-1 7-11 27-9 20-3 1 2-9 8-21-2-1 1-3h-2l-1-4 8-19 3-9 3 1 3-11z"
            fill="#12216E"
          />
          <path
            transform="translate(730,767)"
            d="m0 0 9 1 6 5 1 9-4 6-5 3h-7l-6-4-3-4-1-6 4-7z"
            fill="#020103"
          />
          <path
            transform="translate(1052,1132)"
            d="m0 0 4 4 3 11 1 6-3-2-6 8-7 6-1 2 10 1 7 2v2h2v2h4v4h2v3l-4-2-4-3-9-3h-16l-22 4-6 1 4-5 20-7 12-7 5-5 4-7 1-9z"
            fill="#061481"
          />
          <path
            transform="translate(1208,1258)"
            d="m0 0v3l-14 9-41 23-29 15-2-1 5-3h2l1-5 15-8 27-16 14-9 10-4 8-2z"
            fill="#122063"
          />
          <path
            transform="translate(954,621)"
            d="m0 0 4 1 6 10 5 13 1 4v14l-4 8-6 4h-7l-1-3 8-10 1-2v-11l-6-15-2-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1154,449)"
            d="m0 0h2l1 14 1 27v48l-3 28-2 14-2 2-2-5v-6l3-5v-13l1-4v-27z"
            fill="#08167E"
          />
          <path
            transform="translate(814,1461)"
            d="m0 0 2 4-3 9-13 40-9 36-2 6-4-2v-9l8-29 8-25 2-1 5-14 5-13z"
            fill="#112070"
          />
          <path
            transform="translate(796,1461)"
            d="m0 0 2 4-10 28-8 26-6 25-3 17-2 1-1-2-2 6h-1v-8l7-31 9-31 5-15h3l1-5z"
            fill="#112070"
          />
          <path
            transform="translate(826,674)"
            d="m0 0h3l-1 9-7 16v11l2 1h8l5-4 11-23 4-3 1 5-7 16-6 10-8 5-7 1-6-3-3-5v-11l5-14z"
            fill="#071481"
          />
          <path
            transform="translate(710,1240)"
            d="m0 0h9l7 6 1 2-1 9-7 6h-9l-6-5-2-8 3-6z"
            fill="#020103"
          />
          <path
            transform="translate(281,1077)"
            d="m0 0h11l-1 3-3 2-7 2-10 4-2 3h14l8 3 5 8-2 1-22-2-2-1v-2l-6-1-5-4h2l2-5 9-8z"
            fill="#061482"
          />
          <path
            transform="translate(731,1352)"
            d="m0 0h1l1 6v8l8-5 17-4h10l7 3v3l-6-1h-14l-11 4-9 7-10 17-14 26-4 1 1-6 11-21 11-20 1-11z"
            fill="#071580"
          />
          <path
            transform="translate(1151,930)"
            d="m0 0 24 1 4 2 3 8 6 2-6 7-6 4-5 2h-6v-2h-9l-2-2 17-2 7-4 2-3-16 1-7-3-4-5z"
            fill="#071580"
          />
          <path
            transform="translate(542,336)"
            d="m0 0h2l8 13 3 6 6 9 4 8 9 16 11 19 10 18 4 6-2 4-5-5-15-27-16-29-14-25-6-10z"
            fill="#061482"
          />
          <path
            transform="translate(614,462)"
            d="m0 0h1v8l-7 28-12 38-8 22h-3l3-12 3-8-1-3 10-30 8-32 3-4v-5z"
            fill="#12206F"
          />
          <path
            transform="translate(550,1538)"
            d="m0 0h3v13l-2 4-25 2h-23l-8-3-1-7 2-2 13 6 3 1h13l12-4 9-6z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(549,1530)"
            d="m0 0 1 4-8 8-11 5-12 3-10-1-10-5-3-2v-3h28l16-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(756,1471)"
            d="m0 0 2 4-9 28-8 31-4 22-4 3-1 5h-1v-10l5-25 7-28 4-13 1 2h2l2-9z"
            fill="#061382"
          />
          <path
            transform="translate(1404,1808)"
            d="m0 0h1l1 35v97l-3 12-5 10-9 10-9 7-12 5-8 1-4-2 16-4 11-6 8-7 8-13 3-11 1-15z"
            fill="#030209"
          />
          <path
            transform="translate(631,457)"
            d="m0 0h4l-2 12-9 38-9 29-11 29-1 2h-2l1-5 6-15v-7l10-30 11-44z"
            fill="#11206F"
          />
          <path
            transform="translate(1087,704)"
            d="m0 0 7 1 6 3v2l6 2v4l-11 9-8 5-4-1-1-1v-14l3-8z"
            fill="#DFCE40"
          />
          <path
            transform="translate(690,1320)"
            d="m0 0 15 1 10 5 1 2-10-3h-16l-12 4-8 6-6 7-10 20-6 8h-3l2-7 10-19 4-13 1-5h1l1 5 10-6 10-4z"
            fill="#061481"
          />
          <path
            transform="translate(1166,1066)"
            d="m0 0h3l3 7v11l-5 7-6 3-9 1-9-3-6-7v-4l5 1 4 2h11l6-5z"
            fill="#020103"
          />
          <path
            transform="translate(822,1490)"
            d="m0 0 3 1-3 11-9 30-8 32-2 11-3 1-1-3v-8l8-33 10-35 1 2h2z"
            fill="#071580"
          />
          <path
            transform="translate(482,1593)"
            d="m0 0h3l1 4-7 9-7 11-7 9-4 5-5 7-4 8-14 20-4 2-3-1 30-44 14-20z"
            fill="#071481"
          />
          <path
            transform="translate(900,1359)"
            d="m0 0h2v2h11 4l9 1 1 2-17 1-11 4-9 6-13 13-11 15-6 10-4 1-1 2-1-3h2l-1-4 10-15 12-14 9-8 13-8h2z"
            fill="#061382"
          />
          <path
            transform="translate(1128,1300)"
            d="m0 0 2 2-3 3-4 2-3 3-34 17-36 16-18 7h-3l2-4 11-5 2-3 10-2 28-12 36-18z"
            fill="#050716"
          />
          <path
            transform="translate(663,596)"
            d="m0 0h3l-1 6-8 17-12 19-7 10-2 5-14 7-2-1 5-4 14-19 9-15 12-22z"
            fill="#061383"
          />
          <path
            transform="translate(926,481)"
            d="m0 0h13l10 3 6 5-1 4-8-1-10-2-12 1-14 5-8 4v-4l9-8 12-6z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(428,671)"
            d="m0 0 3 1-8 5-2 2 1 2-11 5 2 5 1 4-5 9-6 8v-3l6-10-1-5-3-3v-2l-18 4-3 2-10 3-2 2-10 4-17 8-2-1 19-10 27-13 25-11z"
            fill="#132269"
          />
          <path
            transform="translate(590,537)"
            d="m0 0 2 1-6 18-1 2h2l-1 5-14 29-11 18-3 1-2-1v-6l11-17 10-19 11-27z"
            fill="#051383"
          />
          <path
            transform="translate(759,1370)"
            d="m0 0 11 1 6 4 4 4v3h-3l-5-5-4-2h-11l-8 4-9 11-9 15-12 23-4-1 4-10 10-19 10-16 7-7 8-4z"
            fill="#061382"
          />
          <path
            transform="translate(366,1300)"
            d="m0 0h1v15l-2 15-5-1-17-9v-2l14-11z"
            fill="#DFCE40"
          />
          <path
            transform="translate(804,476)"
            d="m0 0h15l6 2 4 3 1 2-8-1-5-1h-12l-13 4-19 9-14 9-5 3-3-1 2-4 9-7 14-8 14-6z"
            fill="#061482"
          />
          <path
            transform="translate(802,663)"
            d="m0 0h4l-1 7-9 17-4 12v12l4 11 4 6-1 2-7-8-3-6-3-14-11 2 5-5 7-8 8-16 5-9z"
            fill="#051383"
          />
          <path
            transform="translate(1066,1262)"
            d="m0 0h2v7l-1 5-1-3-18 6h-2l5 10 3 4v3h-3l-6-8-11-7-23-9-4-2 1-2 7 1 14 4 7 1h13l10-3 5-4z"
            fill="#13216D"
          />
          <path
            transform="translate(1023,351)"
            d="m0 0 4 1-4 7-3 7-16 23-11 16-13 19-4 6-3-1 1-2h2l3-9 4-9 5-5 10-15 10-14 10-16z"
            fill="#061482"
          />
          <path
            transform="translate(260,990)"
            d="m0 0h8l6 3 1 1v8l-3 3-18 2-5-2-1-7 7-6z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(603,660)"
            d="m0 0 2 4 5 2-2 2-11 3-8 3-23 1-12 1-7-3-7-2-1-1-8 1-1 1-7-1-10-6v-3l10 4 9 1 11-1 1 3 9-2-4 5h12l10-4 4 1 4-1v2h8l8-4 4-3 1 2-1 2 3-1-1-4z"
            fill="#0F1A52"
          />
          <path
            transform="translate(960,559)"
            d="m0 0 4 2 3 7 3 16v18h-4l-6-9-1-2v-27z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(453,1133)"
            d="m0 0 7 1 13 6-1 5-5 4-16 4h-6l1-5z"
            fill="#DFCF40"
          />
          <path
            transform="translate(693,562)"
            d="m0 0h1l1 10-12 29-8 15-7 12h-3l1 3-4 3-2-4 12-19 9-19 10-28z"
            fill="#051383"
          />
          <path
            transform="translate(482,1429)"
            d="m0 0 4 2 4 6 2 8-1 30-2 3-3-4-4-22-1-21z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(998,879)"
            d="m0 0h7l-1 5-7 13-4 2-18-9v-3l12-5z"
            fill="#DFCD3F"
          />
          <path
            transform="translate(922,992)"
            d="m0 0h1v24l4 1 14 7-1 2-10-3-2-1v19l16-6h6l2 1v-2h2v3h-5l-9 4-8 4-6 5-2-1-1 2-1-1z"
            fill="#061482"
          />
          <path
            transform="translate(485,913)"
            d="m0 0 8 6 5 2 9 8 5 3v3l-5-1-6-1-10 9-10 13-4 4-3-4h-2l-2 3-6 2h-7l1-3h4v-2l12-5 10-7 9-8 4-5-1-4-3-1-3-5-5-5z"
            fill="#061482"
          />
          <path
            transform="translate(434,1666)"
            d="m0 0 2 2-7 7-9 14-4 10-8 12-13 19h-3l-3 1-1-2 11-16 16-23 15-22h4z"
            fill="#11206F"
          />
          <path
            transform="translate(903,538)"
            d="m0 0 2 1 4 17v12l-4 6-18 11-3 1-2 4-2 3h-2l1-6 4-5 8-7 9-7 3-3v-10l-2-8v-7h2z"
            fill="#071580"
          />
          <path
            transform="translate(571,1439)"
            d="m0 0h2l-1 6-4 6-5 4-14 8-2 2-1 24-2-1-3-15v-12l5-5 18-10 5-5z"
            fill="#12216E"
          />
          <path
            transform="translate(292,1503)"
            d="m0 0 2 2v7l2 4 1 14 2 2v40l-3 7h-2l-2-63z"
            fill="#14236C"
          />
          <path
            transform="translate(763,1496)"
            d="m0 0 2 2-3 14 1 5-7 30-3 13-2 2-1-1-2 3v-8l5-26 9-33z"
            fill="#061382"
          />
          <path
            transform="translate(963,860)"
            d="m0 0h3l5 14 1 4v9l-7-1-11-6 1-6 7-13z"
            fill="#DFCF40"
          />
          <path
            transform="translate(980,1051)"
            d="m0 0 4 1 13 10 5 6-21 6h-3l1-11z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(695,1522)"
            d="m0 0h9l-2 4-13 10-21 11-15 5-12 2h-7l-4-1v-2l22-3 14-5 15-8 13-9h2z"
            fill="#0F1D74"
          />
          <path
            transform="translate(338,1414)"
            d="m0 0h1l1 10 2-4 1 28v142h-1l-1-14v-95l-1-29h-2z"
            fill="#020F8A"
          />
          <path
            transform="translate(758,1398)"
            d="m0 0h3l-1 6-22 45-2 5-4-1 2-8 13-28 8-16z"
            fill="#061382"
          />
          <path
            transform="translate(493,1420)"
            d="m0 0 3 1 3 4-1 19-1 16h-2l-1 4h-2l-1-19-3-10-5-5-2 1 1-5 2-5 4 5 5 5z"
            fill="#041185"
          />
          <path
            transform="translate(432,912)"
            d="m0 0h8l-3 7-5 8-1 3v12l3 6 9 6 7 4v2l-3 3-4-2-14-14-3-2-5-10-6-7-3-5 1-2 9 12 4-4 6-11h2l-1-2-4-2z"
            fill="#0B1978"
          />
          <path
            transform="translate(1187,1025)"
            d="m0 0 8 1 3 3-1 6-7 6-3 1h-7l-5-4v-6l6-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(470,957)"
            d="m0 0 4 1-2 7-1 15-5-2-13-10-3-3v-3l2-1 12-2z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(516,1301)"
            d="m0 0h14l5 1v1l-16 1-10 5-3 1-2 4-3 5-1 4v17l2 9-1 4-1-6-4 1v-2h-6l2-4h3v-23l5-9 8-6z"
            fill="#0A187C"
          />
          <path
            transform="translate(290,940)"
            d="m0 0h9l8 3 6 7 1 2v6l-4-1-6-7-4-2h-8l-10 6h-4l1-7 6-5z"
            fill="#020103"
          />
          <path
            transform="translate(1105,722)"
            d="m0 0h3v20h-18l-4-1 1-4 7-7z"
            fill="#DFCE40"
          />
          <path
            transform="translate(1025,1093)"
            d="m0 0 5 4 9 14 1 4-3 1h-17l-2-1 1-5 4-10z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(283,990)"
            d="m0 0 5 4 4 4 1 5-4-1-3-4-6 1v5l4 4-1 5-6-2h-8l-16 3 2-4 2-1 1-3 16-2 1-10z"
            fill="#071481"
          />
          <path
            transform="translate(776,1456)"
            d="m0 0 1 3 3-1-1 6 1 2-10 28-6 19-3-1 3-15-1-3 11-33z"
            fill="#09177D"
          />
          <path
            transform="translate(282,1051)"
            d="m0 0h4l1 6-1 4h2v2l10 2-1 4h-9l-5-4-4-5-8 1-12 5-6 3v-5l-7-1v-1l13-2z"
            fill="#071481"
          />
          <path
            transform="translate(1071,1211)"
            d="m0 0 2 3v19l-3 1-18-10v-3l15-8z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(387,859)"
            d="m0 0h7l13 4 1 3-11 14-4 1-7-20z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(949,635)"
            d="m0 0 4 2 4 9 1 10-4 6-5 1-4-7-1-4v-8l4-8z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(344,1290)"
            d="m0 0h20l2 1-2 4-16 14-4 1-1-14z"
            fill="#DECA3F"
          />
          <path
            transform="translate(896,678)"
            d="m0 0 3 1 1 3-2 2-4 2-3 2 1 7 6 17 7 11 11 6 12 1v1l-12 2-7-3v-3l-6-2-6-8-9-19v-7l-1-4-9-2 2-3z"
            fill="#13226D"
          />
          <path
            transform="translate(922,1388)"
            d="m0 0h11l6 4 4 5 1 7-2 4-5-1v-7l-1-4-6-2-9 1-5 3-2 3h-2v2l-4 1-2-1 2-5 4-5z"
            fill="#051284"
          />
          <path
            transform="translate(394,738)"
            d="m0 0 4 1 11 12 1 3-21 7h-2l4-16z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(810,1377)"
            d="m0 0h5l-1 3-9 6-13 13-2-2-2 4h-2v-3l-7 3v-2h2v-3h-2l2-4-1-5-2-5h2l1-2 5 10 5-1 8-5z"
            fill="#061482"
          />
          <path
            transform="translate(1064,1271)"
            d="m0 0h2l-2 10-5 13h-4l-7-10-2-4v-3z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(928,1022)"
            d="m0 0 8 2 13 7-1 3-14 6-6 1-1-2v-14z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(523,989)"
            d="m0 0h3v21l-6-1-14-6-1-3 17-10z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(830,1518)"
            d="m0 0 1 4-2 10 1 5-8 36-4 1v-11l6-28 4-15z"
            fill="#061482"
          />
          <path
            transform="translate(498,1372)"
            d="m0 0h6l3 4 1 9-3 9-4 3-4-6-3-8v-8z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(410,915)"
            d="m0 0h17l6 2-7 14-4 3-7-9-5-7z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(754,1424)"
            d="m0 0 3 1-5 10v7l-9 24-3 9-2-2-2 2h-2l2-9 11-28z"
            fill="#13216D"
          />
          <path
            transform="translate(1146,989)"
            d="m0 0h9l6 3 1 7-5 4-7 1-7-3-2-3 1-6z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1057,1150)"
            d="m0 0 3 3 4 10 1 8-9-1-13-3 2-4 8-7z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(407,807)"
            d="m0 0h35v2h-2v2l2 1h-23l-16 2-10 4-9 3 2-4 12-7h2v-2z"
            fill="#061481"
          />
          <path
            transform="translate(730,771)"
            d="m0 0h6l5 4 1 7-4 5-7 1-4-2-3-6 1-5z"
            fill="#DECC3F"
          />
          <path
            transform="translate(561,1342)"
            d="m0 0 4 4 7 3v1l-17 4-17 8-4 3h-2v-3h-4l-1-3 3-1 1 2 6-5 6-3 5-1 1-2 8-1v-2l3-1z"
            fill="#041285"
          />
          <path
            transform="translate(516,617)"
            d="m0 0 5 1-2 4-3 3 1 7 6 2h8l5-1-1 5-3 3h-11l-8-5-3-5 1-9z"
            fill="#08167F"
          />
          <path
            transform="translate(777,1395)"
            d="m0 0 4 1v3h-2l-1 4-11 11-7 11-7 15h-2l1-7 4-8-1-3 7-11 11-12z"
            fill="#051383"
          />
          <path
            transform="translate(298,1032)"
            d="m0 0 7 1 4 5-1 6-4 3-7 1-5-3-2-3 1-6 4-3z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(635,1511)"
            d="m0 0h9l6 4 7 10v2h-5l-8-9-2-1h-7l-5 6-2 4-4 1-1-5 5-8z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(917,674)"
            d="m0 0 5 1 3 8 1 4v12l-5 1-3-3-4-14v-7z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(478,1422)"
            d="m0 0 1 2-1 8h3l3 27 3 15v3h-2l-1 2-3-7-3-14-1-9v-26z"
            fill="#061382"
          />
          <path
            transform="translate(382,798)"
            d="m0 0 11 7 6 4-3 3-13 8-3-1v-11l1-9z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1e3 653)"
            d="m0 0 5 1 40 19 8 5v2h-5l-16-8-29-14-4-3z"
            fill="#12216E"
          />
          <path
            transform="translate(49,1913)"
            d="m0 0h1l1 24 3 14 6 11 8 9 11 7 7 3 9 2-2 2-11-2-10-5-10-8-8-11-4-8-2-7v-12z"
            fill="#070B22"
          />
          <path
            transform="translate(526,1334)"
            d="m0 0h5l5 10 2 6v5l-7 4-4-9-3-9v-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(711,1244)"
            d="m0 0h7l5 5-1 7-2 3-8 1-5-4-1-6 3-5z"
            fill="#DFCE40"
          />
          <path
            transform="translate(898,630)"
            d="m0 0 2 1-2 5-12 6-4 1h-12l-11-4-6-4-1-3 15 5h16l10-4z"
            fill="#071580"
          />
          <path
            transform="translate(823,502)"
            d="m0 0 3 1-1 7-4 6-6 4h-9l-6-3-4-6-1-5 4-1 6 8 3 2 6-1 5-6 2-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1201,1217)"
            d="m0 0 5 1 8 4 1 2v12l-4-1-14-10 1-5z"
            fill="#DECC3F"
          />
          <path
            transform="translate(941,503)"
            d="m0 0h5v7l-4 6-6 4-6 1-9-4-4-8v-5l4 1 6 9 2 1h6l4-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(697,597)"
            d="m0 0h2v2h2l-1 5-12 16-7 10-4 2-5 1-2 1 2-5 8-7 12-16z"
            fill="#051383"
          />
          <path
            transform="translate(912,1401)"
            d="m0 0 1 3-1 5h-3l1 2-4 2 2 1-6 5-6 9-4-2h-3l7-11 9-13 7 1z"
            fill="#11206F"
          />
          <path
            transform="translate(608,1453)"
            d="m0 0 4 2 4 7-1 8-6 7-8 4h-5l1-5 9-6 3-5z"
            fill="#111F70"
          />
          <path
            transform="translate(312,728)"
            d="m0 0 2 1-15 10-14 10-9 6-7 6h-3v2l-9 6h-2v2l-8 4-2-1 9-8 16-11 15-10 17-11z"
            fill="#14236C"
          />
          <path
            transform="translate(566,1390)"
            d="m0 0h16l10 3 6 5-3 1-13-4h-13l-17 5h-2l2-4 10-5z"
            fill="#08157F"
          />
          <path
            transform="translate(942,1027)"
            d="m0 0 7 1 14 7 10 7 10 8-4 1h-2l-3 1-4-7-6-4-5-2-11-1 1-2 5 1v-3h-2v2l-6-1 2-4-6-3z"
            fill="#13226C"
          />
          <path
            transform="translate(902,345)"
            d="m0 0h6l5 4v6l-5 5-7-1-4-5v-5z"
            fill="#DFD040"
          />
          <path
            transform="translate(482,1593)"
            d="m0 0h3l1 4-7 9-7 11-6 8-6 2-1 2 1-5 11-15 10-15z"
            fill="#08157F"
          />
          <path
            transform="translate(809,1531)"
            d="m0 0h1l-1 9v3l-1 8-5 24-3 1-1-3v-8l8-33z"
            fill="#061382"
          />
          <path
            transform="translate(695,502)"
            d="m0 0 2 1-4 18-9 30-6 18-2-1 1-6 9-30 5-18 3-11z"
            fill="#12216E"
          />
          <path
            transform="translate(516,1511)"
            d="m0 0h10l5 4 4 8-1 3-4-1-5-8-7-1-6 5-4 7-3-1 3-9z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(848,549)"
            d="m0 0h5l-9 9-1 3v7l3 6 3 2 7 1-1 2h-3v2l-6-1-5-4-4-8 1-9 4-6z"
            fill="#071481"
          />
          <path
            transform="translate(777,1661)"
            d="m0 0h6l5 5-1 6-3 3h-8l-4-4 1-7z"
            fill="#DECB3F"
          />
          <path
            transform="translate(982,627)"
            d="m0 0h1l1 9 5 8 9 5 6 3v3l-6-1-14-6v13h-1l-2-17-5-15 3 1 1 2z"
            fill="#09177D"
          />
          <path
            transform="translate(676,562)"
            d="m0 0 1 2v8l-10 26-4-1-3 2 2-6 12-30z"
            fill="#08157F"
          />
          <path
            transform="translate(237,797)"
            d="m0 0 5 1 13 8-1 6-5 1-12-5z"
            fill="#DECB3F"
          />
          <path
            transform="translate(665,628)"
            d="m0 0h2v3l4 1-3 5h-3l1 3-5 2v8l2 4-1 3-3-4-2-6-6-4 6-9 4-2h3z"
            fill="#12216D"
          />
          <path
            transform="translate(667,353)"
            d="m0 0h6l5 4-1 7-7 4-6-3-2-4 1-5z"
            fill="#DFCD3F"
          />
          <path
            transform="translate(91,51)"
            d="m0 0h8l1 2-16 3-12 6-9 8-8 13-3 8-1 6-3-4 3-10 7-12 5-6 11-8 12-5z"
            fill="#070A20"
          />
          <path
            transform="translate(662,1670)"
            d="m0 0 5 1 4 4-1 6-4 4-7-1-4-5 1-5 3-3z"
            fill="#DFCF40"
          />
          <path
            transform="translate(793,1521)"
            d="m0 0 1 4-1 4h2l-1 8-4 18h-4l-1-1v-9l6-22z"
            fill="#051383"
          />
          <path
            transform="translate(1157,931)"
            d="m0 0h18l4 2 1 4-5 3h-13l-5-6z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(834,1593)"
            d="m0 0h6l1 8-9 1-18-1-2-2 3-2z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(776,1515)"
            d="m0 0h1l-1 9-2 11-1 1v13l-2 12-2 1-1-2-2 6h-1v-8l7-31 3-11z"
            fill="#061482"
          />
          <path
            transform="translate(783,344)"
            d="m0 0 7 1 3 4-1 6-3 3h-7l-4-4-1-4 4-5z"
            fill="#DFD040"
          />
          <path
            transform="translate(942,645)"
            d="m0 0h2v5l-5 4-1 2 3 1-4 1-3 4h-2l-2 5-6-1-1 2v-2l-3 1v-3l12-12 5-1 2-4z"
            fill="#13226C"
          />
          <path
            transform="translate(538,1668)"
            d="m0 0 6 1 4 5-1 5-4 3h-6l-4-4 1-7z"
            fill="#DFCE40"
          />
          <path
            transform="translate(735,1556)"
            d="m0 0h1l-1 15-2 16-5 1-1-6 3-22z"
            fill="#12216E"
          />
          <path
            transform="translate(922,992)"
            d="m0 0h1v24l4 1 14 7-1 2-10-3-2-1v3l-3 1v9l-2 15h-1z"
            fill="#11206F"
          />
          <path
            transform="translate(525,980)"
            d="m0 0h1l1 6-5 5-15 9h-7l-3-3 3-2h5v-2l10-4 8-6z"
            fill="#051284"
          />
          <path
            transform="translate(411,1703)"
            d="m0 0 1 2-17 25h-3l-3 1-1-2 11-16 3-4 5-2z"
            fill="#13226D"
          />
          <path
            transform="translate(1052,1132)"
            d="m0 0 4 4 3 11 1 6-3-2-6 8-4 4h-5v2h-2l2-5 5-5 4-5 2-9z"
            fill="#08157F"
          />
          <path
            transform="translate(282,1025)"
            d="m0 0 1 3 5 2v2l-7-1-16 4-10 3 1-4h-7v-1l12-2 11-5z"
            fill="#071580"
          />
          <path
            transform="translate(833,524)"
            d="m0 0 2 1-2 5-15 10-11 5-3-1 2-4 19-11z"
            fill="#071580"
          />
          <path
            transform="translate(607,428)"
            d="m0 0h9l14 2v4l-14 4-5-1-4-7z"
            fill="#BD2B1A"
          />
          <path
            transform="translate(923,478)"
            d="m0 0h14l1 2h-12v2l-12 5-9 7-1 1h-5v-4l10-7 10-5z"
            fill="#071580"
          />
          <path
            transform="translate(603,660)"
            d="m0 0 2 4 5 2-2 2-11 3-8 3-21-1v-3l5-2 2 1 4-1v2h8l8-4 4-3 1 2-1 2 3-1-1-4z"
            fill="#13226D"
          />
          <path
            transform="translate(656,1440)"
            d="m0 0 3 2-1 5-8 5-9 1-8-4 1-4 4 1h9l5-3z"
            fill="#08167F"
          />
          <path
            transform="translate(1008,1266)"
            d="m0 0 7 1 14 4 7 3 5 2 2 5-4 1-12-6-19-7z"
            fill="#071580"
          />
          <path
            transform="translate(1152,972)"
            d="m0 0h8l4 3-1 5-5 3h-6l-4-4 1-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(693,503)"
            d="m0 0 1 3-2 8-11 39-3 9-3 1 2-9 8-27 6-23z"
            fill="#071580"
          />
          <path
            transform="translate(756,1471)"
            d="m0 0 2 4-9 28-4 15-2-2 1-9 3-10-1-5 2-4v2h2l2-9z"
            fill="#111F70"
          />
          <path
            transform="translate(1153,1022)"
            d="m0 0h7v2h-2l4 5h-2l2 6 2 4h10v2l-8 3h-3l-6-8-6-13z"
            fill="#071481"
          />
          <path
            transform="translate(349,852)"
            d="m0 0 3 1 1 2 5 3 12 13 12 16-1 2-4-2-10-13-9-10-7-8v-2h-2z"
            fill="#080D2A"
          />
          <path
            transform="translate(671,527)"
            d="m0 0 3 1-3 11-7 21-5 13h-3l1-5 8-23z"
            fill="#12216E"
          />
          <path
            transform="translate(1152,1010)"
            d="m0 0h8l4 4-1 5-3 2h-7l-4-4 1-6z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(888,697)"
            d="m0 0 5 2 6 15 6 9 11 6 12 1v1l-12 2-7-3v-3l-6-2-6-8-9-19z"
            fill="#070A20"
          />
          <path
            transform="translate(412,756)"
            d="m0 0h11l16 4 4 2 10 2-4 4-9-3-14-3v-2l-11-1-3-1z"
            fill="#061383"
          />
          <path
            transform="translate(858,723)"
            d="m0 0 1 3-5 7-15 9-22-1-9-3-6-5h3l8 4 11 2h9l12-4 7-5h2l2-4z"
            fill="#14236C"
          />
          <path
            transform="translate(706,599)"
            d="m0 0h2l-1 5-6 15-7 14h-2l2-9 7-19z"
            fill="#071580"
          />
          <path
            transform="translate(545,1457)"
            d="m0 0 3 1v6l-1 1-1 24-2-1-3-15v-12z"
            fill="#061481"
          />
          <path
            transform="translate(695,1522)"
            d="m0 0h9l-2 4-13 10-7 4h-3v-4l15-10h2z"
            fill="#061382"
          />
          <path
            transform="translate(780,1380)"
            d="m0 0 3 4 3 6 5-1 2-2 3 1-3 2-1 4h-2l-2 7h-2v-3l-7 3v-2h2v-3h-2l2-4-1-5-2-5h2z"
            fill="#12216D"
          />
          <path
            transform="translate(1151,930)"
            d="m0 0 6 1 3 6 2 2h13l5-2 2 4 2 2h-8l-12 1-7-3-4-5z"
            fill="#09177D"
          />
          <path
            transform="translate(485,913)"
            d="m0 0 8 6 5 2 9 8 5 3v3l-5-1-6-1-3 1-2-1 1-6-4-2-3-5-5-5z"
            fill="#061382"
          />
          <path
            transform="translate(784,1549)"
            d="m0 0h1l2 6 2 1-1 9-2 12-4-2v-2l-2 2 1-11z"
            fill="#13226C"
          />
          <path
            transform="translate(1039,1111)"
            d="m0 0 5 5v2h2l5 10-1 2-4-5-7-4-16-2v-2l-4-1 20-1z"
            fill="#071580"
          />
          <path
            transform="translate(1e3 1066)"
            d="m0 0 5 2 5 4 1 4-6-2h-13l-9 3h-6l-1-2h4v-2l19-5z"
            fill="#071581"
          />
          <path
            transform="translate(530,1019)"
            d="m0 0h1l-1 23-4 34-2 12h-1v-12l1-1 1-10v-19l2-2 2-24z"
            fill="#14236C"
          />
          <path
            transform="translate(291,1014)"
            d="m0 0h6l5 4 1 5-7 2-7-2-1-1v-6z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1194,995)"
            d="m0 0 2 1v4l2 1-19 7h-7l2-2 3-1 2-3h2v-2z"
            fill="#071580"
          />
          <path
            transform="translate(394,895)"
            d="m0 0 3 1 9 16 3 4v2l3 1 3 7 6 8 5 8-1 2-10-13-8-11-8-14z"
            fill="#020206"
          />
          <path
            transform="translate(958,565)"
            d="m0 0h1l1 26 1 5-1 2h-2l-1 7h-1l-1-8v-17l1-9z"
            fill="#041186"
          />
          <path
            transform="translate(1038,1168)"
            d="m0 0h15l7 2v2h2v2h4v4h2v3l-4-2-4-3-11-4-12-1-3-2z"
            fill="#051284"
          />
          <path
            transform="translate(788,506)"
            d="m0 0 4 2 4 7v3l-10-2-7-4 1-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(537,1512)"
            d="m0 0 10 2 2 2v5l-10 4-3-5v-7z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(517,911)"
            d="m0 0 2 1v3h3l3 17v12l-3-4-1-7h-2l-1-13-2-6z"
            fill="#08167F"
          />
          <path
            transform="translate(520,1490)"
            d="m0 0 8 1 10 5 2 3 8 1v6l-5-1-23-14z"
            fill="#071481"
          />
          <path
            transform="translate(295,1493)"
            d="m0 0h2l1 7v30l-2 4-1-18-2-6v-7l1-4v-5z"
            fill="#051284"
          />
          <path
            transform="translate(290,1056)"
            d="m0 0h12l1 5-2 3-7 1-6-2-1-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(779,514)"
            d="m0 0 7 1 12 4 2-1 5 4 3 2h-10l-18-6-2-1z"
            fill="#061482"
          />
          <path
            transform="translate(862,1359)"
            d="m0 0h22l1 3-6 3v-4l-5 2-6 7v-3l3-5-8 1-5 2-4 1-3 2-3-1 8-6z"
            fill="#14236C"
          />
          <path
            transform="translate(380,802)"
            d="m0 0h1v17l4 1 5-1-6 8-3 10-2-2-1-17v-13z"
            fill="#13216D"
          />
          <path
            transform="translate(1194,968)"
            d="m0 0 4 5-13 5-9 5-4-1 1-4h2v-2l12-4z"
            fill="#071481"
          />
          <path
            transform="translate(639,1490)"
            d="m0 0 3 1-5 5-14 9-5 1 1-5 11-7z"
            fill="#071580"
          />
          <path
            transform="translate(909,507)"
            d="m0 0 5 1 3 9-1 1h-7l-6-4 1-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(659,1515)"
            d="m0 0 7 1 6 4-1 4-9 3-3-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(400,901)"
            d="m0 0 8 6 5 4 12 1 2 2-3 1h-14l-1 3-8-13z"
            fill="#08167E"
          />
          <path
            transform="translate(385,852)"
            d="m0 0 1 2 6 1 8 3 18 1 3 2h-7l-4 1v2l-5-1-11-3-7-2-2-3z"
            fill="#041186"
          />
          <path
            transform="translate(1066,1262)"
            d="m0 0h2v7l-1 5-1-3-18 6-4-1 1-2h4v-2l10-3 5-4z"
            fill="#08167F"
          />
          <path
            transform="translate(307,1406)"
            d="m0 0 2 4 1 4 1 1v14l-2 10-2-1-2-9 2-9z"
            fill="#041185"
          />
          <path
            transform="translate(822,1490)"
            d="m0 0 3 1-3 11-7 23h-2l-1 2 1-9 3-10 3-9z"
            fill="#13216D"
          />
          <path
            transform="translate(638,560)"
            d="m0 0 2 2-7 19-1 7-2 4-5 1 1-5 11-27z"
            fill="#071580"
          />
          <path
            transform="translate(60,1963)"
            d="m0 0 5 5 10 8 11 5 9 2-2 2-11-2-10-5-10-8-3-5z"
            fill="#090F2E"
          />
          <path
            transform="translate(649,454)"
            d="m0 0 4 1-3 13 1 4-2 1-4 16-2 3v-7l5-28z"
            fill="#051383"
          />
          <path
            transform="translate(275,1095)"
            d="m0 0h7l6 3 1 4h-9l-10-2-1-3z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(993,1364)"
            d="m0 0 3 1-29 12-8 2 2-4 19-7z"
            fill="#0A187C"
          />
          <path
            transform="translate(805,578)"
            d="m0 0h7l7 5 1 3-14-1-4-2-3-1v-2z"
            fill="#071580"
          />
          <path
            transform="translate(1189,1021)"
            d="m0 0 2 1-1 2 2 1-11 3-7 5-1-2-5-2 1-4 12-1z"
            fill="#061382"
          />
          <path
            transform="translate(453,752)"
            d="m0 0 6 4 10 17-1 4-6-5-3-5-4-10z"
            fill="#071481"
          />
          <path
            transform="translate(838,1497)"
            d="m0 0 2 3-3 11-6 21h-3l3-14 5-16z"
            fill="#12206F"
          />
          <path
            transform="translate(1011,990)"
            d="m0 0 3 1 5 25 3 11v3l-3-1-7-29z"
            fill="#050615"
          />
          <path
            transform="translate(929,579)"
            d="m0 0 9 1 5 3 3 5v8l-3 1-3-9-7-5-4-2z"
            fill="#061481"
          />
          <path
            transform="translate(618,1515)"
            d="m0 0 4 1v7l-3 5-6-2-1-5 4-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1049,1224)"
            d="m0 0 7 1 14 8 1 3-2 4h-2l-6-7-11-6z"
            fill="#071481"
          />
          <path
            transform="translate(401,687)"
            d="m0 0 10 1 3 4-1 6-7 10-4 4 2-5 5-8-1-5-3-3v-2h-5z"
            fill="#030309"
          />
          <path
            transform="translate(485,1343)"
            d="m0 0h6l-1 3-12 5-6 5-3 4h-3l2-5 4-5 10-6z"
            fill="#08167E"
          />
          <path
            transform="translate(900,1359)"
            d="m0 0h2v2h11 4l9 1 1 2-17 1-10 3v-2l-3-1 4-1z"
            fill="#12206F"
          />
          <path
            transform="translate(1073,1232)"
            d="m0 0 1 3-2 17-3 15h-1l-1-6 2-6v-11l-1-4 2-6z"
            fill="#13226C"
          />
          <path
            transform="translate(380,1126)"
            d="m0 0 2 1-4 5-8 3-9 2h-13l-2-2 17-2 10-3z"
            fill="#0B1237"
          />
          <path
            transform="translate(977,1049)"
            d="m0 0 3 2v12l-2 9-2-2-1-3v-15z"
            fill="#12216E"
          />
          <path
            transform="translate(759,468)"
            d="m0 0 5 1 4 3-15 6h-5l6-7z"
            fill="#061382"
          />
          <path
            transform="translate(1404,1913)"
            d="m0 0 2 3v24l-2 8-3-1 1-5z"
            fill="#111D5B"
          />
          <path
            transform="translate(400,808)"
            d="m0 0h6l-3 6-10 4-9 3 2-4 12-7h2z"
            fill="#061482"
          />
          <path
            transform="translate(517,1506)"
            d="m0 0h10l7 2 3 2-7 2-5-1h-12v-3z"
            fill="#051383"
          />
          <path
            transform="translate(700,545)"
            d="m0 0 2 4-3 11-3 9-2-2-2-6 3-7 3-1z"
            fill="#08167E"
          />
          <path
            transform="translate(729,1503)"
            d="m0 0 2 2-2 10-3 13-4 1 1-10 3-7z"
            fill="#0B197A"
          />
          <path
            transform="translate(1163,1029)"
            d="m0 0 6 1 3 3-1 5h-7l-4-4 1-4z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(282,997)"
            d="m0 0 5 1 3 4-1 4-6 1-4-3v-5z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(666,459)"
            d="m0 0 5 1-1 11h-4l-1 6-2 1v-7z"
            fill="#051284"
          />
          <path
            transform="translate(721,686)"
            d="m0 0 9 12 11 7 7 2 16 1v1l-13 1-12-3-11-8-8-10z"
            fill="#112070"
          />
          <path
            transform="translate(911,531)"
            d="m0 0 7 1 10 6 2 2-1 3-17-8z"
            fill="#071580"
          />
          <path
            transform="translate(831,504)"
            d="m0 0 6 2 1 3-2 4-3 2h-5l1-9z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(508,1442)"
            d="m0 0 15 8-1 2h-8l-6-3-1-5z"
            fill="#071580"
          />
          <path
            transform="translate(656,1548)"
            d="m0 0m-9 1h9l-3 3-12 2h-7l-4-1v-2z"
            fill="#081580"
          />
          <path
            transform="translate(493,1420)"
            d="m0 0 3 1 3 4-1 19h-1v-7l-5 1v-4l4-2 1-2-3 1z"
            fill="#13226C"
          />
          <path
            transform="translate(758,1357)"
            d="m0 0h10l7 3v3l-18-2-5-2v-1z"
            fill="#13226C"
          />
          <path
            transform="translate(1043,1338)"
            d="m0 0 5 2v2l2 1-18 7h-3l2-4 11-5z"
            fill="#0C1A78"
          />
          <path
            transform="translate(463,1625)"
            d="m0 0 2 1-4 5-5 7-4 8-2-2 2-4-2-1 8-12z"
            fill="#12206F"
          />
          <path
            transform="translate(472,954)"
            d="m0 0 4 2 1 2 2-1-3 9-3 7-2-1v-7l2-7-2-1z"
            fill="#101E72"
          />
          <path
            transform="translate(1401,1948)"
            d="m0 0 3 1-4 9-6 9-7 7-2-1 10-13z"
            fill="#06081B"
          />
          <path
            transform="translate(1155,968)"
            d="m0 0h9l5 5 1 4-2 1-3-1v-2l-5-2-6-2z"
            fill="#061382"
          />
          <path
            transform="translate(614,462)"
            d="m0 0h1v8l-4 5-3 12-3 4 1-9 3-11 2-2v-5z"
            fill="#08167E"
          />
          <path
            transform="translate(945,636)"
            d="m0 0h2l-1 5-2 4-5 3-2 4-4 1 2-5 7-11z"
            fill="#071580"
          />
          <path
            transform="translate(984,1253)"
            d="m0 0 5 1 4 10 1 5-4-1-6-11z"
            fill="#061382"
          />
          <path
            transform="translate(764,1491)"
            d="m0 0 5 4-3 12-2 6-3-1 3-15-1-3z"
            fill="#0F1D74"
          />
          <path
            transform="translate(478,1415)"
            d="m0 0 5 2 1 2v6l-3 7h-3z"
            fill="#031087"
          />
          <path
            transform="translate(410,909)"
            d="m0 0 6 1h18l6-1v3l-3 1-7 1 4 2-1 2-9-3 1-2-12-1z"
            fill="#14236C"
          />
          <path
            transform="translate(484,1421)"
            d="m0 0 4 5 5 7h-3l-1 4-4-6h-3l-1-3z"
            fill="#14236C"
          />
          <path
            transform="translate(508,277)"
            d="m0 0 2 1v5l7 10-1 2-7-5-4-7v-5z"
            fill="#031087"
          />
          <path
            transform="translate(436,952)"
            d="m0 0 5 1 8 4 1 3-3 3-4-2-7-7z"
            fill="#061482"
          />
          <path
            transform="translate(531,1510)"
            d="m0 0h5l1 3v10h-3l-4-8-2-3z"
            fill="#13226C"
          />
          <path
            transform="translate(659,1425)"
            d="m0 0 2 2 1 3v10l-3 4-3-3-1-4 1-3 3-1z"
            fill="#14236C"
          />
          <path
            transform="translate(466,890)"
            d="m0 0h3v2l3 1v4l-6 2-5 1-1-2 3-4h2z"
            fill="#041285"
          />
          <path
            transform="translate(1152,541)"
            d="m0 0h1l1 10-1 2v13l-3 5-2 4 1-11z"
            fill="#14236C"
          />
          <path
            transform="translate(610,1541)"
            d="m0 0 4 1 3 4 10 3 7 1-4 1v2l-10-2-9-6z"
            fill="#101F71"
          />
          <path
            transform="translate(1023,351)"
            d="m0 0 4 1-6 10-5 6-3-1z"
            fill="#020F8A"
          />
          <path
            transform="translate(489,993)"
            d="m0 0 16 1v1l-7 2 2 2 5 1v2l-9-2-8-5z"
            fill="#12216E"
          />
          <path
            transform="translate(527,963)"
            d="m0 0h2v28h-1v-12h-2l-1-10z"
            fill="#051284"
          />
          <path
            transform="translate(901,719)"
            d="m0 0 7 6 8 4 12 1v1l-12 2-7-3v-3l-6-2z"
            fill="#122065"
          />
          <path
            transform="translate(790,700)"
            d="m0 0h1l2 15 6 12v3l-7-8-3-6z"
            fill="#112070"
          />
          <path
            transform="translate(942,647)"
            d="m0 0 2 3 3 8-1 4-3 1-2-7h-3l2-4z"
            fill="#051383"
          />
          <path
            transform="translate(938,518)"
            d="m0 0h5l-1 3-5 3-11 2-1-3z"
            fill="#061382"
          />
          <path
            transform="translate(1e3 361)"
            d="m0 0h2l-1 5-4 6h-3l-1-2v-6z"
            fill="#DDC73E"
          />
          <path
            transform="translate(500,1517)"
            d="m0 0 5 1-3 9h-5v-7z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(653,1422)"
            d="m0 0 5 2 2 4v6h-5l-2-5-1-6z"
            fill="#041186"
          />
          <path
            transform="translate(1010,1117)"
            d="m0 0 3 1-3 6-11 6-3-1 5-5 8-6z"
            fill="#071481"
          />
          <path
            transform="translate(374,695)"
            d="m0 0m-2 1h2l-2 4-10 4-17 8-2-1 19-10z"
            fill="#14236C"
          />
          <path
            transform="translate(428,946)"
            d="m0 0 7 6 12 12 8 7 2 3-4-2-12-11-13-13z"
            fill="#020103"
          />
          <path
            transform="translate(1154,449)"
            d="m0 0h2l1 14v19h-1v-13h-2z"
            fill="#14236C"
          />
          <path
            transform="translate(548,1332)"
            d="m0 0 2 3 4 11 3 2-7 1-4-12 1-3z"
            fill="#0F1D73"
          />
          <path
            transform="translate(1042,670)"
            d="m0 0 14 7 1 3h-5l-9-5v-2h-2z"
            fill="#0F1D74"
          />
          <path
            transform="translate(478,1422)"
            d="m0 0 1 2-1 8h3l1 7v10h-1l-1-9-1-2-1 11h-1v-26z"
            fill="#13226C"
          />
          <path
            transform="translate(862,1359)"
            d="m0 0 8 1-3 2-9 3-4 1-3 2-3-1 8-6z"
            fill="#13216D"
          />
          <path
            transform="translate(470,952)"
            d="m0 0 3 1-3 5-6 2h-7l1-3h4v-2z"
            fill="#071481"
          />
          <path
            transform="translate(1065,1168)"
            d="m0 0 2 3 3 7 1 13-2-3-2-7 1-3h-2v-4h-4v-2l-2-1h5z"
            fill="#14236C"
          />
          <path
            transform="translate(401,1710)"
            d="m0 0h4l-2 5-4 4-2 4-3 3-1-4z"
            fill="#08167E"
          />
          <path
            transform="translate(683,539)"
            d="m0 0 1 3-6 20-3 1 2-9 4-13z"
            fill="#061482"
          />
          <path
            transform="translate(951,503)"
            d="m0 0h3l1 6-5 5-2-1 1-8z"
            fill="#FDFDFD"
          />
          <path
            transform="translate(1194,897)"
            d="m0 0 10 3v2h-18l-2-2 8-1z"
            fill="#031087"
          />
          <path
            transform="translate(1146,652)"
            d="m0 0 3 1 2 6v6l-5-1-1-3v-7z"
            fill="#051284"
          />
          <path
            transform="translate(640,562)"
            d="m0 0 2 2-8 20h-2l2-9 5-12z"
            fill="#11206F"
          />
          <path
            transform="translate(756,1471)"
            d="m0 0 2 4-5 15h-3l2-9z"
            fill="#12216E"
          />
          <path
            transform="translate(932,1368)"
            d="m0 0 6 4 6 3 2 4-10-3-3-2v-2h-4v-2h3z"
            fill="#14236C"
          />
          <path
            transform="translate(858,723)"
            d="m0 0 1 3-5 7-10 6h-4v-2l14-7 2-4z"
            fill="#12216E"
          />
          <path
            transform="translate(716,549)"
            d="m0 0h1v6l-5 13h-2l1-7 3-10z"
            fill="#051383"
          />
          <path
            transform="translate(413,1695)"
            d="m0 0 1 3-7 11h-4l2-5 6-8z"
            fill="#071481"
          />
          <path
            transform="translate(1052,1132)"
            d="m0 0 4 4 3 11 1 6-5-4v-7l-2-1z"
            fill="#13226D"
          />
          <path
            transform="translate(416,676)"
            d="m0 0 4 1h-2l-1 4-7 3-5-1v-2z"
            fill="#061382"
          />
          <path
            transform="translate(534,1545)"
            d="m0 0h4v2h-3v3l-3 1h-8v-3z"
            fill="#071481"
          />
          <path
            transform="translate(1040,1161)"
            d="m0 0 2 1-2 3h2v-2l3 1-2 3 4 1-13 1 1-5z"
            fill="#12216E"
          />
          <path
            transform="translate(428,671)"
            d="m0 0 3 1-8 5-2 2 1 2-9 4-2-1 6-4 2-5z"
            fill="#14236C"
          />
          <path
            transform="translate(949,626)"
            d="m0 0h2l1 3 3 3 2 4v3h-4l-3-5z"
            fill="#061383"
          />
          <path
            transform="translate(871,1650)"
            d="m0 0 3 1 4 7-1 3-5-3-2-4z"
            fill="#DAB63A"
          />
          <path
            transform="translate(631,581)"
            d="m0 0 2 3-2 7-6 2 1-5 4-6z"
            fill="#08167F"
          />
          <path
            transform="translate(399,1721)"
            d="m0 0v3l-5 7-2-1-3 1-1-2 4-6 3 2z"
            fill="#12206F"
          />
          <path
            transform="translate(822,1490)"
            d="m0 0 3 1-3 11-2 5-2-1 1-7z"
            fill="#12206F"
          />
          <path
            transform="translate(737,1472)"
            d="m0 0 2 1-1 9-2-2-2 5-3-1 3-9z"
            fill="#0A187B"
          />
          <path
            transform="translate(1396,73)"
            d="m0 0 3 3 5 10v4l-3-1-4-9-2-6z"
            fill="#0A1034"
          />
          <path
            transform="translate(1018,1082)"
            d="m0 0 5 5 6 7-1 2-2-2-2 2-1-3-1 8h-1l-1-14z"
            fill="#14236C"
          />
          <path
            transform="translate(1145,634)"
            d="m0 0 2 2 1 11 1 5h-2l-2-2-2-4z"
            fill="#020F88"
          />
          <path
            transform="translate(669,530)"
            d="m0 0 1 4-5 12-3 2 3-11 2-6z"
            fill="#071580"
          />
          <path
            transform="translate(631,457)"
            d="m0 0h4l-2 10h-2v3h-2l1-11z"
            fill="#071580"
          />
          <path
            transform="translate(608,595)"
            d="m0 0 1 3-6 12-4-2 2-5h2z"
            fill="#061382"
          />
          <path
            transform="translate(697,1321)"
            d="m0 0h8l10 5 1 2-10-3-14-1v-1l5-1z"
            fill="#0F1E72"
          />
          <path
            transform="translate(1169,1029)"
            d="m0 0 6 3 2 7 1 2h-4v-2h-10v-1l7-1-1-5z"
            fill="#12216E"
          />
          <path
            transform="translate(432,912)"
            d="m0 0h8l-3 7-4 1v-4l-4-2z"
            fill="#031087"
          />
          <path
            transform="translate(794,688)"
            d="m0 0 1 2-3 9-2-2-3 3-2-4 4-4 1 1z"
            fill="#12216E"
          />
          <path
            transform="translate(677,1537)"
            d="m0 0h2l1 4-8 4-4-1v-2z"
            fill="#0C1A78"
          />
          <path
            transform="translate(952,1034)"
            d="m0 0h2v3h-5l-6 3h-5l1-3 5-2h6l2 1z"
            fill="#051383"
          />
          <path
            transform="translate(790,696)"
            d="m0 0 1 4-1 13h-1l-2-11-5-1 2-4 4 2z"
            fill="#020F8A"
          />
          <path
            transform="translate(570,367)"
            d="m0 0h6l2 3v5l-2 1-3-3z"
            fill="#DCC23D"
          />
          <path
            transform="translate(1354,51)"
            d="m0 0h10l7 2-2 3-9-2-9-1z"
            fill="#0E1749"
          />
          <path
            transform="translate(392,1728)"
            d="m0 0v3l-6 8-5 2 2-5 4-6 4-1z"
            fill="#061382"
          />
          <path
            transform="translate(450,1640)"
            d="m0 0h2l-1 7h-3l-4 6-3 1 2-5z"
            fill="#061482"
          />
          <path
            transform="translate(854,1410)"
            d="m0 0 2 1v3l3 1-5 9-2-2v-3l-1-3z"
            fill="#112070"
          />
          <path
            transform="translate(539,1345)"
            d="m0 0h2l3 6 5-1-3 3-6 1-2 1-1-7h2z"
            fill="#14236C"
          />
          <path
            transform="translate(927,1018)"
            d="m0 0 9 3 5 3-1 2-10-3-3-2z"
            fill="#14236C"
          />
          <path
            transform="translate(495,932)"
            d="m0 0 3 1-2 4-7 8-2-4z"
            fill="#14236C"
          />
          <path
            transform="translate(1153,568)"
            d="m0 0h1l-1 12-2 2-2-5v-5z"
            fill="#051383"
          />
          <path
            transform="translate(54,80)"
            d="m0 0 1 3-3 8-1 6-3-4 3-10z"
            fill="#080D29"
          />
          <path
            transform="translate(448,1646)"
            d="m0 0 2 1-2 5-7 10-2-4h2l2-5z"
            fill="#13226D"
          />
          <path
            transform="translate(1054,1271)"
            d="m0 0 3 1 1 2-10 3-4-1 1-2h4v-2z"
            fill="#09177D"
          />
          <path
            transform="translate(988,1071)"
            d="m0 0 3 1 2 2-9 3h-6l-1-2h4v-2z"
            fill="#08167E"
          />
          <path
            transform="translate(444,906)"
            d="m0 0h3l-2 4-1 3-6 4-2-2h3l1-7z"
            fill="#0B197B"
          />
          <path
            transform="translate(385,852)"
            d="m0 0 1 2 6 1 7 2-2 1v2l-4-1-7-1z"
            fill="#061481"
          />
          <path
            transform="translate(532,633)"
            d="m0 0h4l-1 5-3 2-6-1 1-3h4z"
            fill="#031087"
          />
          <path
            transform="translate(1021,361)"
            d="m0 0v3l-10 15-2 1 1-4 4-8 5-5z"
            fill="#14236C"
          />
          <path
            transform="translate(966,1084)"
            d="m0 0h5l-1 3-7 4-4 4v-3z"
            fill="#08167F"
          />
          <path
            transform="translate(1011,990)"
            d="m0 0 3 1 2 15h-2l-3-12z"
            fill="#040613"
          />
          <path
            transform="translate(903,675)"
            d="m0 0 2 1 4 1v2l-2 1 2 2-6 2-2-4v-4z"
            fill="#13216D"
          />
          <path
            transform="translate(602,659)"
            d="m0 0 5 1 1 2-2 3-2-1-1-3v3 3l-5 1 2-7z"
            fill="#08167F"
          />
          <path
            transform="translate(681,553)"
            d="m0 0 2 1-5 15-2-1 1-6 3-8z"
            fill="#111F70"
          />
          <path
            transform="translate(722,529)"
            d="m0 0 2 2v6l-1 2h-4l1-9z"
            fill="#041285"
          />
          <path
            transform="translate(700,545)"
            d="m0 0 2 4-3 11-3 1 2-10z"
            fill="#101E72"
          />
          <path
            transform="translate(671,527)"
            d="m0 0 3 1-3 11-2 2-1-5z"
            fill="#12216E"
          />
          <path
            transform="translate(672,521)"
            d="m0 0h3l-1 7-3-1v3l-3 1 2-9z"
            fill="#051383"
          />
          <path
            transform="translate(938,479)"
            d="m0 0 8 1 2 1v2l-9-1-13-1v-1z"
            fill="#12216E"
          />
          <path
            transform="translate(832,1518)"
            d="m0 0 2 1-3 13h-3l3-13z"
            fill="#111F70"
          />
          <path
            transform="translate(954,681)"
            d="m0 0h1l1 5 6 1v1h-9v14h-1l-1-14 2-2z"
            fill="#14236C"
          />
          <path
            transform="translate(661,560)"
            d="m0 0 2 2-4 11h-3l1-5 3-7z"
            fill="#111F70"
          />
          <path
            transform="translate(79,1979)"
            d="m0 0 16 4-2 2-11-2-3-2z"
            fill="#070B23"
          />
          <path
            transform="translate(571,1439)"
            d="m0 0h2l-1 6-1 2-4 2-3-1z"
            fill="#0B197A"
          />
          <path
            transform="translate(977,1049)"
            d="m0 0 3 2v12h-2v-8h-2l-1-3z"
            fill="#061482"
          />
          <path
            transform="translate(612,470)"
            d="m0 0 2 4-2 9-3 1v-7z"
            fill="#13216D"
          />
          <path
            transform="translate(753,1475)"
            d="m0 0 1 4-4 11h-2l1-7 3-7z"
            fill="#051284"
          />
          <path
            transform="translate(1022,1091)"
            d="m0 0 2 2v7l-3 8h-2l1-7h2z"
            fill="#08157F"
          />
          <path
            transform="translate(1006,1069)"
            d="m0 0 5 3 1 4-6-2-11-1v-1l11-1z"
            fill="#13226C"
          />
          <path
            transform="translate(432,918)"
            d="m0 0 1 2h2l-4 10-2-2-2 1 2-5z"
            fill="#0D1C76"
          />
          <path
            transform="translate(482,909)"
            d="m0 0 4 1 9 9-1 2-11-9z"
            fill="#0F1E72"
          />
          <path
            transform="translate(374,878)"
            d="m0 0 5 5 3 5h-4l-4-5z"
            fill="#0E184B"
          />
          <path
            transform="translate(380,802)"
            d="m0 0h1l-1 17-2-1v-13z"
            fill="#14236C"
          />
          <path
            transform="translate(982,627)"
            d="m0 0h1l1 11-3-1v-2h-3l-2-6 3 1 1 2z"
            fill="#14236C"
          />
          <path
            transform="translate(614,462)"
            d="m0 0h1v8l-5 5-1-4 2-2v-5z"
            fill="#031087"
          />
          <path
            transform="translate(808,1474)"
            d="m0 0 1 2-6 16-1-4 4-13z"
            fill="#071481"
          />
          <path
            transform="translate(779,1454)"
            d="m0 0h3l1 4-3 6-2 1 1-6h-2l1-4z"
            fill="#041185"
          />
          <path
            transform="translate(498,1367)"
            d="m0 0 5 2 3 3-1 2-1-1h-6l-3 1 1-4z"
            fill="#14236C"
          />
          <path
            transform="translate(1044,1328)"
            d="m0 0 1 4 1 5 1 2-5-1-1-1v-6z"
            fill="#030309"
          />
          <path
            transform="translate(1047,1284)"
            d="m0 0h2l5 7v3h-3l-5-7z"
            fill="#0D1B76"
          />
          <path
            transform="translate(895,707)"
            d="m0 0 2 3 4 7 1 6-4-4-4-9z"
            fill="#080E2B"
          />
          <path
            transform="translate(884,583)"
            d="m0 0 2 3h-2l-2 4-2 3h-2l1-6 3-3z"
            fill="#14236C"
          />
          <path
            transform="translate(747,1488)"
            d="m0 0 3 2 2-1-1 8h-3l-2-5z"
            fill="#0F1D74"
          />
          <path
            transform="translate(1063,1233)"
            d="m0 0h7l1 3-2 4h-2l-4-5z"
            fill="#061382"
          />
          <path
            transform="translate(996,1127)"
            d="m0 0 2 1-1 3-5 3-6 1 1-3z"
            fill="#0E1C75"
          />
          <path
            transform="translate(764,1491)"
            d="m0 0 5 4-1 5-4 1-1-7z"
            fill="#12216E"
          />
          <path
            transform="translate(1039,1111)"
            d="m0 0 5 5v2h2l-2 4-6-5z"
            fill="#14236C"
          />
          <path
            transform="translate(513,654)"
            d="m0 0 11 2-2 1-1 3-3 1v-3l-4-1z"
            fill="#14236C"
          />
          <path
            transform="translate(780,699)"
            d="m0 0 8 3 1 10h-1l-2-10-11 2z"
            fill="#13226C"
          />
          <path
            transform="translate(1370,54)"
            d="m0 0 6 1 4 2 2 4-6-2-6-3z"
            fill="#0A1032"
          />
          <path
            transform="translate(1366,1981)"
            d="m0 0 5 1-3 2-8 1-4-2z"
            fill="#0A1034"
          />
          <path
            transform="translate(656,1548)"
            d="m0 0m-9 1h9l-3 3-10 1z"
            fill="#09177E"
          />
          <path
            transform="translate(763,1496)"
            d="m0 0 2 2-2 9-4 3 2-9z"
            fill="#08167F"
          />
          <path
            transform="translate(634,1445)"
            d="m0 0 5 2 2 3-5 1-3-2z"
            fill="#051384"
          />
          <path
            transform="translate(527,1032)"
            d="m0 0h1v12l-2 4-1-5 1-10z"
            fill="#020206"
          />
          <path
            transform="translate(258,1006)"
            d="m0 0h8v1h-5l-2 6-6 1 2-4 2-1z"
            fill="#12216E"
          />
          <path
            transform="translate(802,732)"
            d="m0 0 5 2 10 5v1l-7-1-8-6z"
            fill="#13226D"
          />
          <path
            transform="translate(884,681)"
            d="m0 0h7v3l-5 2-3-2z"
            fill="#051285"
          />
          <path
            transform="translate(926,667)"
            d="m0 0 2 1-2 2v5l-2-1-2 2-5-2 5-4z"
            fill="#14236C"
          />
          <path
            transform="translate(995,649)"
            d="m0 0 5 1 4 2v3l-6-1-2-1z"
            fill="#0C1B78"
          />
          <path
            transform="translate(811,1529)"
            d="m0 0 2 1-3 13-3-1 3-12z"
            fill="#12206F"
          />
          <path
            transform="translate(768,1478)"
            d="m0 0h3v5h1v5l-3 2v-5l-1-1z"
            fill="#051383"
          />
          <path
            transform="translate(561,1342)"
            d="m0 0 4 4 7 3v1l-9 1 2-2-5-2z"
            fill="#14236C"
          />
          <path
            transform="translate(1017,1220)"
            d="m0 0h17l-1 3-16-2z"
            fill="#020F8A"
          />
          <path
            transform="translate(392,813)"
            d="m0 0 2 1-1 4-9 3 2-4z"
            fill="#0A187B"
          />
          <path
            transform="translate(961,595)"
            d="m0 0 4 5v3l-3 1-2-3v-5z"
            fill="#12216E"
          />
          <path
            transform="translate(684,542)"
            d="m0 0 2 1-3 10h-2l1-8z"
            fill="#12206F"
          />
          <path
            transform="translate(774,1470)"
            d="m0 0 1 3-4 10-1-2 1-3h-2l1-5 3-1z"
            fill="#13226D"
          />
          <path
            transform="translate(740,1461)"
            d="m0 0 1 2h2l-1 6-4 2-1-2z"
            fill="#051284"
          />
          <path
            transform="translate(776,1456)"
            d="m0 0 1 3 3-1-3 10-2-2v-3l-1-2z"
            fill="#14236C"
          />
          <path
            transform="translate(993,1364)"
            d="m0 0 3 1-13 5-3-2z"
            fill="#12216E"
          />
          <path
            transform="translate(1057,1227)"
            d="m0 0 5 2 6 3v1l-6 1-3-2z"
            fill="#0F1E73"
          />
          <path
            transform="translate(1033,1169)"
            d="m0 0 16 2v1l-20 1z"
            fill="#14236C"
          />
          <path
            transform="translate(406,809)"
            d="m0 0 13 2v1l-16 1z"
            fill="#14236C"
          />
          <path
            transform="translate(649,454)"
            d="m0 0 4 1-2 7-3 1z"
            fill="#051284"
          />
          <path
            transform="translate(405,1712)"
            d="m0 0v3l-4 6h-2l-1-3z"
            fill="#14236C"
          />
          <path
            transform="translate(773,1391)"
            d="m0 0 4 5-5 5-1-3z"
            fill="#14236C"
          />
          <path
            transform="translate(384,797)"
            d="m0 0 4 1 8 6h-3l-7-3z"
            fill="#041185"
          />
          <path
            transform="translate(792,718)"
            d="m0 0h2l5 9v3l-7-8z"
            fill="#14236C"
          />
          <path
            transform="translate(721,686)"
            d="m0 0 9 12 1 2-4-2-7-9z"
            fill="#0F1D73"
          />
          <path
            transform="translate(982,619)"
            d="m0 0 2 3v3l-4 3-2-6h3z"
            fill="#14236C"
          />
          <path
            transform="translate(606,592)"
            d="m0 0 2 1-2 6-3 6-2-3z"
            fill="#101F71"
          />
          <path
            transform="translate(511,291)"
            d="m0 0 7 4 2 5-2 1v-3l-4-1-3-4z"
            fill="#0C1A79"
          />
          <path
            transform="translate(977,1369)"
            d="m0 0h6l-1 2-9 3v-2l-2-1z"
            fill="#0B1979"
          />
          <path
            transform="translate(843,1365)"
            d="m0 0h3l1 6-2 3h-2l1-6-5-1z"
            fill="#132167"
          />
          <path
            transform="translate(444,763)"
            d="m0 0h7l2 2-4 3-5-3z"
            fill="#041186"
          />
        </>
      ) : (
        <>
          <path
            transform="translate(0)"
            d="m0 0h1475v2048h-1475z"
            fill="#FEFEFE"
          />
          <path
            transform="translate(0)"
            d="m0 0h1475v2048h-1475zm98 42-14 2-12 5-11 8-7 9-7 14-2 10v1867l2 11 8 16 6 7 13 9 10 4 5 1 1191 1h85l15-1 13-4 11-7 9-9 7-12 3-10 1-9v-1860l-2-14-8-16-12-12-16-8-14-2z"
            fill="#FEFEFE"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            transform="translate(718,854)"
            d="m0 0 7 1 38 19 17 10 22 15 13 10 8 7v2l4 2 25 25 10 14 10 17 6 13 6 22 2 13v26l-4 15-7 14-8 10-7 6-9 6-17 5-20 4-26 2h-32l-20-1v48h59l1 1v25l-1 1h-151v-27h62v-48l-18 1h-33l-26-2-22-4-18-6-14-9-7-8-7-11-5-16-2-11v-21l5-22 4-13 10-22 14-19 7-8 7-7 2-3h2v-2l8-7 14-14 16-11 18-13 15-8 10-6 27-13z"
            fill="#010000"
          />
          <path
            transform="translate(98,42)"
            d="m0 0h1274l14 2 16 8 12 12 8 16 2 14v1860l-2 13-5 12-7 9-7 7-10 6-13 4-15 1h-85l-1191-1-13-4-11-7-5-5-7-8-6-13-2-11v-1867l2-10 8-16 7-8 10-7 12-5zm-6 3-12 3-11 6-9 8-8 13-3 8-1 6v1868l2 11 6 12 9 10 9 7 9 4 14 2h1274l14-2 9-4 9-6 8-8 6-11 3-10 1-8v-1862l-2-11-4-9-6-9-9-9-14-7-10-2z"
            fill="#414141"
          />
          <path
            transform="translate(46,425)"
            d="m0 0h1l1 1523 3 20 6 12 9 10 10 7 11 4 10 1h1274l14-2 9-4 9-6 7-7 6-11 3-10 1-8 1-1 1-12h1v22l-4 12-7 11-9 9-10 6-13 4-15 1h-85l-1191-1-13-4-11-7-5-5-7-8-6-13-2-11v-1531z"
            fill="#323232"
          />
          <path
            transform="translate(1423,94)"
            d="m0 0h1v1860l-3-1v-1857z"
            fill="#717171"
          />
          <path
            transform="translate(46,425)"
            d="m0 0h1l1 1523 3 20 6 12 9 10 10 7 11 4 10 1v1l-13 1-12-5-11-8-8-10-6-13-2-11v-1531z"
            fill="#262626"
          />
          <path
            transform="translate(45,90)"
            d="m0 0 3 1v1857h-1l-1-1522h-1z"
            fill="#6E6E6E"
          />
          <path
            transform="translate(1308,1859)"
            d="m0 0h29l1 4-10 35-4 16-2-1-12-45z"
            fill="#FEFEFE"
          />
          <path
            transform="translate(145,134)"
            d="m0 0 2 1 13 49 1 4h-30l2-9 9-34z"
            fill="#FEFEFE"
          />
          <path
            transform="translate(1422,1941)"
            d="m0 0h1v22l-4 12-7 11-9 9-10 6-13 4-15 1h-85l-137-1 1-2 227-1 14-2 9-4 9-6 7-7 6-11 3-10 1-8 1-1z"
            fill="#323232"
          />
          <path
            transform="translate(88,43)"
            d="m0 0h157v2l-153 1-12 3-11 6-8 7-8 13-3 8-2 8-1 9h-1v-17l5-12 6-9 5-6 10-7 12-5z"
            fill="#414141"
          />
          <path
            transform="translate(1422,1941)"
            d="m0 0h1v22l-4 12-7 11-9 9-10 6-9 3h-2l-1-3 10-3 11-7 8-8 6-11 3-10 1-8 1-1z"
            fill="#454545"
          />
          <path
            transform="translate(1384,44)"
            d="m0 0 9 3 10 6 11 11 8 16 1 4v13l-2-1-3-15-4-9-6-9-8-8-14-7-3-2z"
            fill="#3F3F3F"
          />
          <path
            transform="translate(49,1968)"
            d="m0 0h2l6 12 9 10 10 7 11 4 10 1v1l-13 1-12-5-11-8-8-10-5-10z"
            fill="#383838"
          />
          <path
            transform="translate(1423,94)"
            d="m0 0h1v53l-3 1v-52z"
            fill="#626262"
          />
          <path
            transform="translate(1409,1986)"
            d="m0 0v3l-9 8-12 6-6 1-1-3 10-3 15-9z"
            fill="#3E3E3E"
          />
          <path
            transform="translate(84,44)"
            d="m0 0 8 1v1l-12 3-11 6-5 2 2-4 10-6z"
            fill="#333"
          />
          <path
            transform="translate(50,76)"
            d="m0 0 1 4-3 11-1 9h-1v-17l2-6z"
            fill="#383838"
          />
          <path
            transform="translate(1422,1941)"
            d="m0 0h1v19l-3 3v-9l1-1z"
            fill="#3A3A3A"
          />
          <path
            transform="translate(78 2e3)"
            d="m0 0 9 1 10 1v1l-13 1-6-2z"
            fill="#3A3A3A"
          />
          <path
            transform="translate(1420,83)"
            d="m0 0 3 1v13l-2-1-1-4z"
            fill="#464646"
          />
          <path
            transform="translate(49,1968)"
            d="m0 0h2l4 8v3h-3l-4-8z"
            fill="#323232"
          />
          <path
            transform="translate(67,1994)"
            d="m0 0 6 1 7 4-4 2-9-6z"
            fill="#2C2C2C"
          />
          <path
            transform="translate(62,56)"
            d="m0 0 3 1-6 8-4 1 2-4z"
            fill="#393939"
          />
          <path
            transform="translate(1409,1986)"
            d="m0 0v3l-8 7h-3l1-3 6-3z"
            fill="#242424"
          />
          <path
            transform="translate(1413,1981)"
            d="m0 0 1 2-4 4-6 5-2-1 8-8z"
            fill="#3D3D3D"
          />
        </>
      )}
    </svg>
  );
}
